import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, OnDestroy, Output, ViewChild } from '@angular/core';
import { LazyLoadEvent, MessageService, SelectItem } from 'primeng/api';
import { TaskGridService } from './task-grid.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ProjectsGridService } from '../projects-grid/projects-grid.service';
import { DatePipe } from '@angular/common';
import { AuthGuard } from 'src/app/account/auth/app.gaurd';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import Swal from 'sweetalert2';
import { helperService } from 'src/app/utils/helper';
import { UsersGridService } from '../users-grid/users-grid.service';
import { task } from 'src/app/utils/filterDropDownData';
import { Table } from 'primeng/table';
import { AppConfigService } from '../app-config/app-config.service';
import { TaskCatalogueService } from '../task-catalogue/task-catalogue.service';
import { PaymentMethodSettingsService } from '../payment-method-settings/payment-method-settings.service';
import { VendorGridService } from '../vendor-grid/vendor-grid.service';
import { EscrowAccountsService } from '../escrow-accounts/escrow-accounts.service';
import { NotificationNavigationService } from 'src/app/features/notifications/services/notification-navigation.service';
import { FieldInfo, FieldInfoGridService } from '../field-info-grid/field-info-grid.service';
import { SavedTableState, TableStateService } from 'src/app/shared/table-state.service';
import { TaskEntityIntegrationService } from './task-entity-integration.service';
import { NotificationsService } from 'src/app/features/notifications';

@Component({
    selector: 'app-task-grid',
    templateUrl: './task-grid.component.html',
    styleUrls: ['./task-grid.component.scss'],
    standalone: false
})
export class TaskGridComponent implements OnInit, OnDestroy {
  @Input()
  dashboard: any = false;

  @Input()
  tkdashboard: any = false;

  @Input()
  lpcdashboard: any = false;

  @Input()
  projTasksFilter: any = false;

  @Output()
  tasksChanged = new EventEmitter<void>();

  @ViewChild('dt') table!: Table;

  disbursementTaskDialog: boolean = false;
  prefDisbursementTypes = ["Advanced", "Credit Card on File", "Escrow", "Pre-Invoiced", "Non-Reimbursable"];

  manageDisbursementsDialog: boolean = false;
  manageDisbursementsEnabled: boolean = false;
  manageDisbursementsBtn: boolean = false;
  disbursements: any = [];
  allDbDisbursements: any = [];
  deletedDisbursementTaskIds: any = [];
  newDisbursementTaskIds: any = [];
  vendorList: any = [];
  escrowList: any = [];

  filterDates: any = { taskDueDate: null, createdOn: null, completedDate: null };
  filterDatesMatchModes: any = { taskDueDate: 'dateIs', createdOn: 'dateIs', completedDate: 'dateIs' };

  userTkPracticeAreas: any;
  public tasks: any[] = [];
  public cols: any = [];
  public tkUserCols: any = [];
  colsView: any = {
    showForApproval: false,
    showDeleteTask: false,
    showCloneTask: false,
    showCreateReminder: true
  };
  statuses: any[] = [];
  priorities: any[] = [];
  descriptionTypes: any[] = [];
  taskGridTypes: any[] = [];
  rejectedReason: string = "";
  status = ['ON_HOLD', 'IN_PROGRESS', 'REGECTED'];
  priority = ['Low', 'High', 'Medium'];
  taskTypes = ['Contract', 'Trade Mark', 'Administrative', 'TradeMark', 'Corporate'];
  descriptionType = ['Free', 'Auto'];
  rateType = ['Fixed Rate', 'Hourly'];
  practiceArea = ['Contract Management Services', 'Corporate Services', 'Director Services', 'Family Law', 'Finance Services', 'Fund Services', 'Immigration Services', 'Intellectual Property', 'International Services', 'KYC/AML', 'Labor & Employment', 'Legal Project Services', 'Legal Research', 'Litigation', 'Treasury Services', 'Trusts & Estates', 'Bankruptcy'];
  frozenCols?: any[];
  loadingTkUsers: boolean = true;
  tkSearchTerm: string = '';
  filteredTkUsers: any[] = [];
  loadingDayWiseData: boolean = true;
  loading: boolean = true;
  gridErrorMessage: any = "";
  onlylpcadmin: boolean = false;
  onlytk: boolean = false;
  tkRatingWarning: boolean = false;
  combroles: boolean = false;
  forApprovalDialog: boolean = false;
  btnLoading: boolean = false;
  disableDelbtnFlag: boolean = true;
  disableReassignbtnFlag: boolean = true;
  totalRecords: number = 0;
  first: number = 1;
  loadingData: boolean = false;
  dayoptions: any;
  deleteTRAR: boolean = false;
  deleteConfirmationDialog: boolean = false;
  reminderNotificationDialog: boolean = false;
  reminderDialog: boolean = false;
  deleteConfirmationDialogText: string = "";
  faloading: boolean = false;
  FAdisableFlag: boolean = false;
  matchModeOptionsString?: SelectItem[];
  matchModeOptionsDate: SelectItem[] = [
    { label: 'Date Is', value: 'dateIs' },
    { label: 'Date Before', value: 'ltDate' },
    { label: 'Date After', value: 'gtDate' },
    { label: 'Date Range', value: 'betweenDate' },
  ];
  matchModeOptionsNumber?: SelectItem[];
  viewOnly: boolean = false;
  submitted: boolean = false;
  disableADDTR: boolean = false;
  title: string = "";
  rateTypes: any[] = [];
  taskDialog = false;
  notesRailCollapsed: boolean = false;
  assignmentDetailsExpanded: boolean = false;
  currentTaskRow: any = null;
  states: any = [];
  countries: any = [];
  taskForm: any = [];
  lpcUsersList = [];
  tkUsersList = [];
  paymentMethodsList = [];
  dbPaymentMethodsList = [];
  loadingTRData: boolean = false;
  taskAssignDialog: boolean = false;
  viewTaskAssignmentDialog: boolean = false;
  acceptTaskDialog: boolean = false;
  acceptOpenedFromTaskDialog: boolean = false;
  addTRDialog: boolean = false;
  commentsDialog: boolean = false;
  selectedTaskForComments: any = null;
  TKAssignedUser: string = "";
  assignedInvalid: boolean = false;
  newTaskDialog: boolean = false;
  maxTimewarning: boolean = false;
  allProjects = []
  AllTasks = []
  newTask: any = "";
  filterOptions = task.filters;
  selectedFilterOption: string = 'All Tasks';
  stateCodeMapList: any;
  canadaStateList: any;
  enableReassignTask: boolean = false;
  rejectTimeRecords: boolean = false;
  projectAssignedTasks = [];
  today = new Date();
  selectedProject: any = "";
  projectTaskCols: any = [];
  openedtask: any;
  assignBtnLoading: boolean = false;
  showStateCode: boolean = true;
  showCountry: boolean = true;

  // Entity related - cached flag for performance
  private _isEntityRelatedTask: boolean = false;
  dueDateError: boolean = false;
  isAnyTrApproved: boolean = false;
  enableDeleteTask: boolean = false;
  showQuantityState: boolean = false;
  private lastTableLazyLoadEvent: any = null;

  // Filters from widget or entity navigation
  widgetFilters: any[] = [];
  notifyTaskIdPayload: any=null;
  filterSource: string = ''; // 'widget' or 'entity'
  private navigationSubscription: any;
  private isDestroyed: boolean = false;

  dueDaySlots: any = []
  tkUsers: any = []
  deleteReason: string = '';
  reassignReason: string = '';
  taskAssignedUsers: any = []
  tkRatingMand: boolean = false;
  deleteReasonList = task.deleteReasonList
  reassignReasonList = task.reassignReasonList
  reviewstatuslist = task.reviewstatuslist
  timeSlot = [
    { "label": "30 mins", value: 30 },
    { "label": "1 hour", value: 60 },
    { "label": "1 hour 30 mins ", value: 90 },
    { "label": "2 hours ", value: 120 },
    { "label": "2 hours 30 mins ", value: 150 },
    { "label": "3 hours ", value: 180 },
    { "label": "3 hours 30 mins ", value: 210 },
    { "label": "4 hours ", value: 240 },
    { "label": "4 hours 30 mins ", value: 270 },
    { "label": "5 hours ", value: 300 },
    { "label": "5 hours 30 mins ", value: 330 },
    { "label": "6 hours  ", value: 360 },
    { "label": "6 hours 30 mins ", value: 390 },
    { "label": "7 hours  ", value: 420 },
    { "label": "7 hours 30 mins ", value: 450 },
    { "label": "8 hours  ", value: 480 },
    { "label": "10 hours  ", value: 600 },
    { "label": "18 hours  ", value: 1080 },
    { "label": "24 hours  ", value: 1440 },
    { "label": "48 hours  ", value: 2880 },
    { "label": "72 hours  ", value: 4320 },
  ]
  timeRecords: any[] = []
  hasDuplicateTR: boolean = false;
  openTask: any;
  userCountryInformation: any = []
  preInvoiceDate: any;
  timeRecordsDueDate: any;
  timeRecordsStartDate: any;
  acceptDdata: any;
  daywiseData: any;
  userrole: any;
  viewflag: boolean = true;
  includeToday: Boolean = false;
  rejbtnLoading: Boolean = false;
  accbtnLoading: Boolean = false;
  rejbtnflag: Boolean = true;
  accbtnflag: Boolean = true;
  accepteddaywiseData: any;
  rejectresponse: any = [];
  assignedTime: any;
  trForm: any = [];
  dropdownDates: any = [];
  dropdownTime: any = [];
  defaultTime: any;
  radioStatus: string = "";
  acceptedDates: any;
  loggedInId: string = "";
  assignedTkUserName: string = "";
  assignmentStatuses: any;
  approvalRequiredList: any;
  isRejectedFilter: any;
  assignedTkUser: any;
  confirmMessage: string = "";
  showConfirmAlert: Boolean = false;
  confirmMsgCategory: string[] = []
  showProjectsView: Boolean = false;
  viewTaskName: string = "";
  selectedTask: any = null;
  searchTerm: any = "";
  catalogueRecord: any = null;
  lastSearchTerm: any = '';
  dateFilters: any = [];
  pendingConfirmationAction: string | null = null;
  taskScreenName = 'tasks_grid';
  taskUserId = this.auth?.jwtData?.email;
  taskInitialLoadDone = false;
  taskRestoring = true;
  public defaultFilters: { [s: string]: any } = {};
  activeTab = 'default';  
  gridSettingsDialog: boolean = false;
  
  resetcustomFilter: boolean = false;
  defaultCols: any[] = [];
  customCols: any[] = [];
  availableColumns: any[] = [];
  tableCols: any[] = [];

  cardLoading: boolean = false;
  auditDialog: boolean = false;
  auditField:string="";
  auditRecordId:any;
  auditTitle:string="";
  tableName:string="al_project_tasks";
  disPaymentCompletedEnabled: boolean = false;
  disPaymentCompletedClicked: boolean = false;
  skipIsTKUpdatedEntity: boolean = false;
  basicEntityEditMode: boolean = false;
  
  private taskLoadingSubscription: any;
  minDate = new Date(
    new Date().toLocaleString('en-US', { timeZone: 'America/New_York' })
  );


  // Generic confirmation method
  confirmAction(message: string, action: string) {
    this.confirmMessage = message;
    this.showConfirmAlert = true;
    this.pendingConfirmationAction = action;
  }

  // Handler for confirmation response
  onConfirmResponse(confirmed: any) {
    this.showConfirmAlert = false;
    if (confirmed === 'Yes' || confirmed === true) {
      if (this.pendingConfirmationAction === 'saveTask') {
        this.persisTaskData();
      } else if (this.pendingConfirmationAction === 'approveTask') {
        this.approveTask(this.taskForm, true);
      }else if (this.pendingConfirmationAction === 'markTaskReadyToComplete') {
        this.markTaskReadyToComplete();
      }else if(this.pendingConfirmationAction === 'notReadyToComplete'){
        this.saveTask(true, true);
      }else if (this.pendingConfirmationAction === 'discardTaskEdits') {
        this.closeDialog();
      }
    } else if (confirmed === 'No' || confirmed === false) {
      if (this.pendingConfirmationAction === 'saveTask' && this.confirmMsgCategory.includes('CLOSE_PROJECT')) {
        this.confirmMsgCategory = this.confirmMsgCategory.filter((item: string) => item !== 'CLOSE_PROJECT');
        this.persisTaskData();
      }
    }
    this.pendingConfirmationAction = null;
  }

  // Entity dialog methods - delegate to service
  openEntityDialog() {
    // let obj=this.entityService.entitiesList.find((e:any)=>e.id==this.taskForm.getRawValue().entityId)
    // if(obj){
    //   this.entityService.openEntityDialog(obj);
    //   return;
    // }
    this.entityService.openEntityDialog();
  }

  openEditEntityDialog() {
    this.basicEntityEditMode = this.userrole?.includes('LPC') || false;
    this.skipIsTKUpdatedEntity = this.basicEntityEditMode;
    this.entityService.openEditEntityDialog();
  }

  closeEntityDialog() {
    this.skipIsTKUpdatedEntity = false;
    this.basicEntityEditMode = false;
    this.entityService.closeEntityDialog();
  }

  onEntitySaved(savedEntity: any) {
    this.entityService.onEntitySaved(savedEntity, this.taskForm);
    this.loadEntitiesForDropdown();
  }

  onEntityDialogVisibleChange(visible: boolean) {
    this.entityService.entityDialog = visible;
    if (!visible) {
      this.entityService.closeEntityDialog();
    }
  }

  onUpdateEntityDialogVisibleChange(visible: boolean) {
    this.entityService.updateEntityDialog = visible;
    if (!visible) {
      this.entityService.closeUpdateEntityDialog();
      this.skipIsTKUpdatedEntity = false;
      this.basicEntityEditMode = false;
    }
  }

  // Entity-related task methods
  get isEntityRelatedTask(): boolean {
    return this._isEntityRelatedTask;
  }
  
  private calculateIsEntityRelatedTask(): boolean {
    return this.entityService.isEntityRelatedTask(this.taskForm);
  }

  isEntityInfoComplete(): boolean {
    return this.entityService.isEntityInfoComplete();
  }

  openUpdateEntityDialog(): void {
    this.skipIsTKUpdatedEntity = false;
    this.basicEntityEditMode = false;
    const taskId = this.taskForm?.get('id')?.value;
    this.entityService.openUpdateEntityDialog(taskId);
  }

  closeUpdateEntityDialog(): void {
    this.entityService.closeUpdateEntityDialog();
  }

  loadEntityByTaskId(taskId: number): void {
    this.entityService.loadEntityByTaskId(taskId, (entity) => {
      // Enable taskReadyToComplete checkbox if entity info is complete
      if (this.isEntityRelatedTask && this.isEntityInfoComplete()) {
        this.taskForm.controls['taskReadyToComplete']?.enable();
      }
    });
  }

  onEntityUpdated(updatedEntity: any): void {
    this.entityService.onEntityUpdated(updatedEntity, this.taskForm, !this.basicEntityEditMode);
    
    // Enable taskReadyToComplete checkbox if entity info is now complete
    if (this.isEntityRelatedTask && this.isEntityInfoComplete()) {
      this.taskForm.controls['taskReadyToComplete'].enable();
    }
  }

  // Getters for template access to service properties
  get entityDialog(): boolean { return this.entityService.entityDialog; }
  get entityToEdit(): any { return this.entityService.entityToEdit; }
  get updateEntityDialog(): boolean { return this.entityService.updateEntityDialog; }
  get currentTaskEntity(): any { return this.entityService.currentTaskEntity; }
  get isLoadingEntity(): boolean { return this.entityService.isLoadingEntity; }
  get entitiesList(): any[] { return this.entityService.entitiesList; }

  constructor(
    private datePipe: DatePipe,
    private taskService: TaskGridService,
    private projectService: ProjectsGridService,
    private readonly messageService: MessageService,
    private cdr: ChangeDetectorRef,
    public auth: AuthGuard,
    private filterService: helperService,
    private userservice: UsersGridService,
    private taskCatalogue: TaskCatalogueService,
    private appConfigService: AppConfigService,
    private readonly PaymentMethodSettingsService: PaymentMethodSettingsService,
    private readonly vendorService: VendorGridService,
    private readonly escrowService: EscrowAccountsService,
    private route: ActivatedRoute,
    private notificationNavService: NotificationNavigationService,
    private fieldInfoService: FieldInfoGridService,
    private tableStateService: TableStateService,
    public entityService: TaskEntityIntegrationService,
    private router: Router,
    private notificationService: NotificationsService
  ) {
    // Listen for navigation events to handle widget filter updates when navigating to the same route
    this.navigationSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // Skip if component is destroyed
        if (this.isDestroyed) {
          return;
        }
        
        // Only handle navigation updates after initial load is complete
        // This prevents interference with restoreTaskState during component initialization
        if (!this.taskInitialLoadDone) {
          return;
        }
        
        // Check history.state for navigation data
        const state = history.state;
        if (state && state.filters && (state.fromWidget || state.fromEntity)) {
          this.widgetFilters = state.filters;
          this.filterSource = state.fromWidget ? 'widget' : 'entity';
          setTimeout(() => {
            this.applyWidgetFiltersToUI();
            if (this.lastTableLazyLoadEvent) {
              this.loadTasksData(this.lastTableLazyLoadEvent);
            }
          }, 100);
        }
      }
    });
  }

  ngOnDestroy(): void {
    // Mark component as destroyed to prevent operations on destroyed view
    this.isDestroyed = true;

    // Unsubscribe from navigation events to prevent memory leaks and stale event handling
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }

    // Clean up notification service subscriptions
    this.notificationNavService.destroy();

    // Clean up other subscriptions
    if (this.taskLoadingSubscription) {
      this.taskLoadingSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      const taskId = params.get('taskId'); 
      
      if (taskId && !isNaN(parseInt(taskId))) {
        const idValue = parseInt(taskId, 10);
        
        this.notifyTaskIdPayload = {
          filters: [{ field: "id", operator: "equals", value: idValue }],
          sort: [],
          category: "All Tasks",
          searchTerm: "",
          openAddTRDialog: params.get('type')=='rtc' ? true : false
        };
        
        console.log('Payload updated:', this.notifyTaskIdPayload);
        this.loadTasksData(this.notifyTaskIdPayload);
      }else{
        console.log('Invalid taskId parameter:', taskId);
        this.notifyTaskIdPayload = null;
      }
    });
    // Check for navigation state from widgets or entities using history.state
    const state = history.state;
    if (state && state.filters && (state.fromWidget || state.fromEntity)) {
      this.widgetFilters = state.filters;
      this.filterSource = state.fromWidget ? 'widget' : 'entity';
      // Note: applyWidgetFiltersToUI() will be called by the navigation listener
      // after restoreTaskState completes and sets taskInitialLoadDone = true
    }

    if (this.tkdashboard || this.lpcdashboard)
      this.dashboard = true;
    console.log("inputs", this.tkdashboard, this.lpcdashboard)
    this.userrole = this.auth.roles;
    this.filterOptions = task.filters.filter((opt: any) =>
      !opt.roles || opt.roles.some((r: string) => this.userrole?.includes(r)));
    this.controlactions();
    // this.states = stateData;
    this.stateCodeMapList = task.stateCodeMapList;
    this.canadaStateList = task.canadaStateList;
    this.defaultTime = new Date();
    this.defaultTime.setHours(0, 0, 0, 0);
    this.countries = task.countryList;
    if (this.projTasksFilter)
      this.showProjectsView = false;
    this.getTkPracticeArea();
    console.log("usertkpractice area", this.userTkPracticeAreas)
    this.tableCols = [
      { field: 'id', header: 'Task ID', showHistoryIcon: false, visible: true },
      { field: 'projectId', header: 'Project ID', showHistoryIcon: false, visible: true ,filterType:'numeric'},
      { field: 'parentDisbursementId', header: 'Parent Disbursement ID', showHistoryIcon: false, visible: true,filterType:'numeric' },
      { field: 'disbursementRelated', header: 'Disbursement Related', showHistoryIcon: false, visible: true ,filterType:'boolean'},
      { field: 'taskTypeCode', header: 'Task Type', showHistoryIcon: false, visible: true },
      { field: 'isPreInvoiced', header: 'Pre Invoiced', showHistoryIcon: false, visible: true ,filterType:'boolean'},
      { field: 'isPrePaid', header: 'Pre Paid', showHistoryIcon: false, visible: true ,filterType:'boolean'},
      { field: 'projectIsInvoicePaid', header: 'Invoice Paid', showHistoryIcon: false, visible: true ,filterType:'boolean'},
      { field: 'projectSubmitToBilling', header: 'Billing Submitted', showHistoryIcon: false, visible: true ,filterType:'boolean'},
      { field: 'isBillable', header: 'Billable', showHistoryIcon: false, visible: true ,filterType:'boolean'},
      { field: 'description', header: 'Description', showHistoryIcon: false, visible: true },
      { field: 'stateCode', header: 'State', showHistoryIcon: false, visible: true },
      { field: 'statusCode', header: 'Status', showHistoryIcon: true, visible: true },
      { field: 'isCompleted', header: 'Task Completed', showHistoryIcon: true, visible: true ,filterType:'boolean'},
      { field: 'projTaskAssignmentStatus', header: 'Task Assignment Status', showHistoryIcon: true, visible: true },
      { field: 'isRejected', header: 'Rejected', showHistoryIcon: false, visible: true ,filterType:'boolean'},
      { field: 'reviewStatus', header: 'Review Status', showHistoryIcon: true, visible: true },
      { field: 'taskDueDate', header: 'Due Date', filterType: 'date', showHistoryIcon: true, visible: true },
      { field: 'progress', header: 'Task Progress', showHistoryIcon: false, visible: true },
      { field: 'createdOn', header: 'Created On', filterType: 'date', showHistoryIcon: false, visible: true },
      { field: 'createdBy', header: 'Created By', showHistoryIcon: false, visible: true },
      { field: 'completedDate', header: 'Completed On', filterType: 'date', showHistoryIcon: false, visible: true },
      { field: 'projTaskAssignmentUsername', header: 'Assigned To', showHistoryIcon: false, visible: true },
      { field: 'dueDaySlot', header: 'Due Day Slot', showHistoryIcon: false, visible: true },
      { field: 'practiceAreaCode', header: 'Practice Area', showHistoryIcon: false, visible: true },
      { field: 'rateTypeCode', header: 'Rate Type', showHistoryIcon: false, visible: true },
      { field: 'descriptionTypeCode', header: 'Description Type', showHistoryIcon: false, visible: true },
      { field: 'isApprovalRequired', header: 'Approval Required', showHistoryIcon: false, visible: true ,filterType:'boolean'},
      { field: 'orgName', header: 'Organization Name', showHistoryIcon: false, visible: true },
      { field: 'matterName', header: 'Matter Name', showHistoryIcon: false, visible: true },
      { field: 'entityRelated', header: 'Entity Related', showHistoryIcon: false, visible: true,filterType:'boolean' },

    ];
    
    this.cols=this.tableCols;

    this.fetchColumnSettings();
    this.projectTaskCols = [
      { field: 'taskName', header: 'Task Name' },
      { field: 'taskTypeCode', header: 'Project Type' },
      { field: 'description', header: 'Description' }
    ];

    this.taskForm = new UntypedFormGroup({
      id: new UntypedFormControl(''),
      taskName: new UntypedFormControl(''),
      projectName: new UntypedFormControl(''),
      projectId: new UntypedFormControl(''),
      orgName: new UntypedFormControl(''),
      matterName: new UntypedFormControl(''),
      qbTaskId: new UntypedFormControl(''),
      description: new UntypedFormControl(''),
      descriptionTypeCode: new UntypedFormControl(''),
      timeEstimate: new UntypedFormControl('', [Validators.required]),
      actualTime: new UntypedFormControl(''),
      isEnforceMaximum: new UntypedFormControl(''),
      stateCode: new UntypedFormControl('', [Validators.required]),
      country: new UntypedFormControl('', [Validators.required]),
      isCompleted: new UntypedFormControl(''),
      projTaskAssignmentStatus: new UntypedFormControl(''),
      isBillable: new UntypedFormControl('', [Validators.required]),
      consolidatedTimeRecords: new UntypedFormControl('', [Validators.required]),
      isRequireEstimate: new UntypedFormControl('', [Validators.required]),
      statusCode: new UntypedFormControl(''),
      isApprovalRequired: new UntypedFormControl('', [Validators.required]),
      taskDueDate: new UntypedFormControl('', [Validators.required]),
      projectDueDate: new UntypedFormControl(''),
      openEnded: new UntypedFormControl('', [Validators.required]),
      quantityState: new UntypedFormControl([]),
      quantityNumber: new UntypedFormControl(''),
      maxTime: new UntypedFormControl(''),
      rateTypeCode: new UntypedFormControl(''),
      isStateRelated: new UntypedFormControl(''),
      stateDesc: new UntypedFormControl(''),
      dbConsolidatedTR:new UntypedFormControl(''),
      countryRelated: new UntypedFormControl(''),
      createdOn: new UntypedFormControl(''),
      completedDate: new UntypedFormControl(''),
      createdBy: new UntypedFormControl(''),
      dueDaySlot: new UntypedFormControl(''),
      tkRating: new UntypedFormControl(''),
      quantityType: new UntypedFormControl(''),
      holdTimeUntilComp: new UntypedFormControl('', [Validators.required]),
      approver: new UntypedFormControl('', [Validators.required]),
      approved: new UntypedFormControl(''),
      timeRecordsLoggedTime: new UntypedFormControl(''),
      includeToday: new UntypedFormControl(''),
      projTaskAssignmentTkId: new UntypedFormControl(''),
      projTaskAssignmentUsername: new UntypedFormControl(''),
      quantityRelated: new UntypedFormControl(''),
      progress: new UntypedFormControl(''),
      reviewStatus: new UntypedFormControl(''),
      practiceAreaCode: new UntypedFormControl(''),
      notes: new UntypedFormControl(''),
      driveLink: new UntypedFormControl(''),
      taskInstructions: new UntypedFormControl(''),
      catEnforceMax: new UntypedFormControl(''),
      isRejected: new UntypedFormControl(''),
      projectHoldTimeUntilCompleted: new UntypedFormControl(''),
      isPrePaid: new UntypedFormControl(''),
      isPreInvoiced: new UntypedFormControl(''),
      projectSubmitToBilling: new UntypedFormControl(''),
      taskReadyToComplete: new UntypedFormControl(''),
      projectIsInvoicePaid: new UntypedFormControl(''),
      openTasksFlag: new UntypedFormControl(''),
      dbStatusCode: new UntypedFormControl(''),
      taskTypeCode: new UntypedFormControl(''),
      disbursementTasks: new UntypedFormControl([]),
      paymentReferenceNumber: new UntypedFormControl(''),
      paymentMethod: new UntypedFormControl(''),
      payeeInvoiceNumber: new UntypedFormControl(''),
      payee: new UntypedFormControl(''),
      transactionType: new UntypedFormControl(''),
      disbursementAmount: new UntypedFormControl(''),
      receipt: new UntypedFormControl(''),
      // dateSettled: new FormControl(''),
      datePaid: new UntypedFormControl(''),
      newDisbursementTaskIds: new UntypedFormControl([]),
      escrowAccountId: new UntypedFormControl(''),
      disbursementRelated: new UntypedFormControl(''),
      exportStatus: new UntypedFormControl(''),
      nonBillableReason: new UntypedFormControl(''),
      entityId: new UntypedFormControl(''),
      entityRelated: new UntypedFormControl(''),
      unreadReminderNotifications: new UntypedFormControl([]),
      unreadReminderNotificationCount: new UntypedFormControl(0),
      assignmentStatusChangeCount: new UntypedFormControl(''),
      completedChangeCount: new UntypedFormControl(''),
      statusChangeCount: new UntypedFormControl(''),
      disableForApproval: new UntypedFormControl(''),
      disableForApprovalTitle: new UntypedFormControl(''),
      dueDateChangeCount: new UntypedFormControl(''),
      orgNotes: new UntypedFormControl('')
    });

    this.taskForm.get('isCompleted').valueChanges.subscribe((isCompleted: any) => {
      this.isCompletedOnchange(isCompleted);
    });

    this.taskForm.get('transactionType').valueChanges.subscribe((transactionType: any) => {
      if (transactionType?.toUpperCase() === "ESCROW") {
        this.taskForm.get('escrowAccountId').setValidators([Validators.required]);
        this.taskForm.get('escrowAccountId').updateValueAndValidity();
      } else {
        this.taskForm.patchValue({ escrowAccountId: '' });
        this.clearFormValidation('escrowAccountId');
      }
      if (transactionType?.toUpperCase() === "CREDIT CARD ON FILE") {
        this.taskForm.patchValue({ paymentMethod: '' });
        this.clearFormValidation('paymentMethod');
        this.taskForm.get('paymentMethod').disable();
      } else {
        this.taskForm.get('paymentMethod').enable();
        this.clearFormValidation('paymentMethod');
        if (this.taskForm.getRawValue().isPreInvoiced?.toUpperCase() != "YES" && this.taskForm.getRawValue().taskTypeCode?.toUpperCase() == 'DISBURSEMENTS') {
          this.taskForm.get('paymentMethod').setValidators([Validators.required]);
          this.taskForm.get('paymentMethod').updateValueAndValidity();
        }
      }
    });
    this.taskForm.get('isBillable')?.valueChanges.subscribe((isBillable: any) => {
      if (!this.onlytk) {
        const nonBillableControl = this.taskForm.get('nonBillableReason');
        if (isBillable === 'Yes') {
          // nonBillableControl?.clearValidators();
           this.taskForm.get('nonBillableReason')?.disable();
           this.clearFormValidation('nonBillableReason');
        } else {
          this.taskForm.get('nonBillableReason')?.enable();
          nonBillableControl?.setValidators([Validators.required]);
        }
        nonBillableControl?.updateValueAndValidity();

      }

    });

    this.taskForm.get('consolidatedTimeRecords').valueChanges.subscribe((value: any) => {
      if(this.taskForm.getRawValue().rateTypeCode=="Fixed Rate" && 
          value!=this.taskForm.getRawValue().dbConsolidatedTR){ 
        this.scrollToTopDialog();
        this.messageService.add({ severity:"warn", detail: 'This task is billed at a fixed rate. Changing Consolidate Time Records from the default may impact billing. Proceed with caution and notify your manager if the change is required.'})
      }else{
        this.messageService.clear();
      }
      if (this.taskForm.getRawValue().projectHoldTimeUntilCompleted == 'Yes') {
        this.taskForm.patchValue({ holdTimeUntilComp: 'Yes' });
        this.taskForm.controls['holdTimeUntilComp'].disable();
      } else {
        if (value == 'Yes') {
          this.taskForm.patchValue({ holdTimeUntilComp: 'Yes' });
          this.taskForm.controls['holdTimeUntilComp'].disable();
        } else {
          this.taskForm.patchValue({ holdTimeUntilComp: this.taskForm.controls['holdTimeUntilComp'].value ? this.taskForm.controls['holdTimeUntilComp'].value : null });
          this.taskForm.controls['holdTimeUntilComp'].enable();
        }
      }
    });

    // Make Entity field mandatory when entityRelated is 'Yes'
    this.taskForm.get('entityRelated').valueChanges.subscribe((value: any) => {
      const entityIdControl = this.taskForm.get('entityId');
      if (value && value.trim().toUpperCase() === 'YES') {
        entityIdControl?.setValidators([Validators.required]);
        // Recalculate cached entity related flag
        this._isEntityRelatedTask = true;
      } else {
        entityIdControl?.clearValidators();
        // Recalculate cached entity related flag
        this._isEntityRelatedTask = false;
      }
      entityIdControl?.updateValueAndValidity();
    });
    // Make Entity field mandatory when entityId is 'Yes'
    this.taskForm.get('entityId').valueChanges.subscribe((value: any) => {
      if (value !== null && value !== undefined && value !== '') {
        this.entityService.loadEntityForEdit(value);
      }
    });

    this.trForm = new UntypedFormGroup({
      date: new UntypedFormControl(''),
      description: new UntypedFormControl(''),
      enteredTime: new UntypedFormControl(''),
      taskCompleted: new UntypedFormControl(''),
    })

    this.statuses = task.statuses;
    this.assignmentStatuses = task.assignmentStatuses;
    this.descriptionTypes = task.descriptionTypes;
    this.rateTypes = task.rateTypes;
    this.dueDaySlots = task.dueDaySlots;
    this.approvalRequiredList = task.approvalRequiredList;
    this.isRejectedFilter = task.isRejectedFilter;


    this.projectService.getLPCUsersList({
      "roles": ["LPC", "ADMIN", "Approver"],
      // "userTypes": ["Internal"]
    }).subscribe(res => {
      this.lpcUsersList = res.data;
    })

    this.projectService.getLPCUsersList({
      "roles": ["TK"]
    }).subscribe(res => {
      this.tkUsersList = res.data;
    })
    this.loadAllProjects()
    this.loadAllTasks()
    this.loadEntitiesForDropdown()
    if (this.lpcdashboard || (!this.tkdashboard && !this.onlytk)) {
      this.colsView.showForApproval = true;
      this.colsView.showDeleteTask = true;
    }
    if (this.userrole.includes('LPC') || this.userrole.includes('ADMIN')) {
      this.colsView.showCloneTask = true;
    }
    this.PaymentMethodSettingsService.getPaymentMethods().subscribe(res => {
      const paymentMethods = Array.isArray(res.data) ? res.data : [];
      this.dbPaymentMethodsList = paymentMethods.filter((pm: any) => pm.status?.toUpperCase() === 'ACTIVE');
    });

    this.taskCatalogue.fetchDisbursementTasks().subscribe((res: any) => {
      const tasks = Array.isArray(res.data) ? res.data : [];
      this.allDbDisbursements = tasks.filter((task: any) => task.taskTypeCode === 'Disbursements');
    });

    this.vendorService.getVendorList().subscribe((res: any) => {
      if (res.data && res.data.length > 0) {
        this.vendorList = res.data.filter((vendor: any) => vendor.isActive?.toUpperCase() === 'YES');
      }
    });

    this.escrowService.getEscrowAccounts().subscribe((res: any) => {
      if (res.data && res.data.length > 0) {
        this.escrowList = res.data.filter((escrow: any) => escrow.active?.toUpperCase() === 'ACTIVE');
      }
    });

    // Initialize notification navigation service
    this.notificationNavService.initializeNotificationNavigation(
      this.route,
      (taskId: number) => {
        // If we already have tasks loaded, check immediately
        if (this.tasks && this.tasks.length > 0) {
          this.handleNotificationNavigation();
        }
      }
    );
    const saved = this.projTasksFilter ? null : this.tableStateService.getState(this.taskScreenName+this.activeTab, this.taskUserId);

    if (saved && !this.taskInitialLoadDone) {
      this.restoreTaskState(saved);
    } 
  }


  loadAllTasks() {
    this.taskService.getAllProjectTaskFullNameList().subscribe((res: any) => {

      for (let k = 0; k < res.data.length; k++) {
        let str = "";
        let taskFullName = res.data[k].taskFullName ? res.data[k].taskFullName : "";
        for (let j = 1; j < taskFullName.split(":").length; j++) {
          str = str + String.fromCharCode(160);
          str = str + String.fromCharCode(160);
          str = str + String.fromCharCode(160);
          str = str + String.fromCharCode(160);
          str = str + String.fromCharCode(160);
          str = str + String.fromCharCode(160);
          str = str + String.fromCharCode(160);
        }
        res.data[k].taskName = str + res.data[k].taskName;
      }
      this.AllTasks = res.data;

    })
  }

  loadAllProjects() {
    this.projectService.getProjectsList(null, null, false, {}).subscribe(res => {
      this.allProjects = res.data;
      this.projectAssignedTasks = [];
    })
  }
  consolidatedTimeRecordsChange(value: any, holdTimeUntilComp?: any) {
    if (this.taskForm.getRawValue().projectHoldTimeUntilCompleted == 'Yes') {
      this.taskForm.patchValue({ holdTimeUntilComp: 'Yes' });
      this.taskForm.controls['holdTimeUntilComp'].disable();
    } else {
      if (value == 'Yes') {
        this.taskForm.patchValue({ holdTimeUntilComp: 'Yes' });
        this.taskForm.controls['holdTimeUntilComp'].disable();
      } else {
        this.taskForm.patchValue({ holdTimeUntilComp: holdTimeUntilComp ? holdTimeUntilComp : null });
        this.taskForm.controls['holdTimeUntilComp'].enable();
      }
    }
  }

  loadEntitiesForDropdown() {
    this.entityService.loadEntitiesForDropdown();
  }


  onTaskScopeChange(table?: Table): void {
    if (this.selectedFilterOption === 'Past Dues' || this.selectedFilterOption === 'Billing Closeouts') {
      this.clearTaskSort(table);
    }
    this.loadTasksData(this.lastTableLazyLoadEvent, table);
  }

  isScopeAllowed(scope: string): boolean {
    return this.filterOptions.some((opt: any) => opt.value === scope);
  }

  clearTaskSort(table?: Table): void {
    if (this.lastTableLazyLoadEvent) {
      this.lastTableLazyLoadEvent.sortField = '';
      this.lastTableLazyLoadEvent.sortOrder = 0;
    }
    if (table) {
      table.sortField = '';
      table.sortOrder = 0;
      table.tableService?.onSort(null);
    }
  }

  async loadTasksData(event: LazyLoadEvent, table?: Table) {
    event = event ? event : this.lastTableLazyLoadEvent || { first: 0, rows: 10 };
    let payload;
    if (this.notifyTaskIdPayload) {
      payload = this.notifyTaskIdPayload
      this.lastSearchTerm = "";
      event.first = 1;
      event.rows = 10;
    } else {
      this.saveState(
        this.taskScreenName + this.activeTab,
        this.taskUserId,
        event,
        {
          projTasksFilter: this.projTasksFilter,
          selectedFilterOption: this.selectedFilterOption,
          dateFilters: this.dateFilters,
          widgetFilters: this.widgetFilters,
          searchTerm: this.searchTerm,
        }
      );
      this.lastTableLazyLoadEvent = event;
      payload = await this.buildTaskPayload(event);
      if (table) {
        table._first = 0;
        event.first = 1;
        event.rows = 10;
      } else {
        event.first = event.first ? event.first : 1;
        event.rows = event.rows ? event.rows : 10;
      }
    }
    this.loading = true;
    this.tasks = [];

    if (this.lastSearchTerm != this.searchTerm) {
      event.first = 1
    }

    this.lastSearchTerm = this.searchTerm;
    this.gridErrorMessage = ""
 
    

    if (this.taskLoadingSubscription)
      this.taskLoadingSubscription.unsubscribe();
    this.taskLoadingSubscription = this.taskService.getProjectTaskList(Math.floor(event.first / event.rows + 1), event.rows, this.filterService.useDashboardUrl(this.userrole, this.tkdashboard), payload).subscribe(res => {
      this.tasks = res.data;
      this.tasks.map((obj: any) => {
        obj['actualTime'] = this.filterService.convertTimeNumToStr(obj['actualTime']);

        // --- Assign Task ---
        obj["disableAssignTask"] = false;
        obj["disableAssignTaskTitle"] = '';
        if (obj.isPreInvoiced == "Yes" && obj.isPrePaid == "No") {
          obj['disableAssignTask'] = true;
          obj['disableAssignTaskTitle'] = 'Cannot assign: Pre-invoiced but not prepaid.';
        } else if (obj.isPreInvoiced == "Yes" && obj.isPrePaid == "Yes" && obj.projectSubmitToBilling == 'Yes') {
          obj['disableAssignTask'] = false;
          obj['disableAssignTaskTitle'] = '';
        }
        if ((this.filterService.isPastDate(new Date(obj["taskDueDate"])) && obj.statusCode?.toUpperCase() != 'ASSIGNED') || (obj.approved == 'No')) {
          obj["disableAssignTask"] = true;
          obj["disableAssignTaskTitle"] = 'Cannot assign: Task is past due or not approved.';
        }
        if (this.onlytk || this.tkdashboard) {
          obj['disableAssignTask'] = true;
          obj['disableAssignTaskTitle'] = 'Assignment not allowed for your role.';
        }
        if (obj.statusCode?.toUpperCase() == 'APPROVED') {
          obj['disableAssignTask'] = true;
          obj['disableAssignTaskTitle'] = 'Cannot assign: Task is already approved.';
        }
        if (obj.projectClosedDate && this.filterService.isPastDate(new Date(obj.projectClosedDate))) {
          obj['disableAssignTask'] = true;
          obj['disableAssignTaskTitle'] = 'Cannot assign: Project is closed.';
        }

        // --- Edit Task ---
        obj["disableEditTask"] = false;
        obj["disableEditTaskTitle"] = '';

        if ((!this.userrole.includes('ADMIN') && !this.userrole.includes('LPC')) && (obj.statusCode?.toUpperCase() == 'APPROVED' || obj.statusCode?.toUpperCase() == 'COMPLETED' || obj.statusCode?.toUpperCase() == 'ASSIGNED')) {
          obj["disableEditTask"] = true;
          obj["disableEditTaskTitle"] = 'Cannot edit: Task is assigned or approved or completed.';
        }

        if (this.tkdashboard || this.filterService.isOnlyTKUser(this.userrole)) {
          obj['disableEditTask'] = true;
          obj['disableEditTaskTitle'] = 'Cannot edit: Timekeeper cannot edit tasks.';
        }
        // if (obj.isPreInvoiced == "Yes" && obj.projectSubmitToBilling == 'Yes') {
        //   obj["disableEditTask"] = true;
        //   obj["disableEditTaskTitle"] = 'Cannot edit: Pre-invoiced and submitted to billing.';
        // }

        if (obj.taskTypeCode?.toUpperCase() == 'DISBURSEMENTS') {
          if ((this.onlytk || this.tkdashboard) && (obj.statusCode?.toUpperCase() == 'ASSIGNED' || obj.isCompleted?.toUpperCase() == 'YES')) {
            obj['disableEditTask'] = true;
            obj['disableEditTaskTitle'] = obj.statusCode?.toUpperCase() == 'ASSIGNED'
              ? 'You must accept this task before you can edit it.'
              : 'Cannot edit: Disbursement task is completed.';
          } else {
            obj['disableEditTask'] = false;
          }
        }
        if (obj.exportStatus?.toUpperCase() == 'YES') {
          obj["disableEditTask"] = true;
          obj["disableEditTaskTitle"] = 'Cannot edit: Exported task.';
        }
        if (obj.projectClosedDate && this.filterService.isPastDate(new Date(obj.projectClosedDate))) {
          obj['disableEditTask'] = true;
          obj['disableEditTaskTitle'] = 'Cannot edit: Project is closed.';
        }

        // Disable Manage Reminders
        obj["disableManageReminders"] = false;
        obj["disableManageRemindersTitle"] = '';
        if (obj.statusCode?.toUpperCase() == 'COMPLETED'||obj.isCompleted == "Yes") {
          obj['disableManageReminders'] = true;
          obj['disableManageRemindersTitle'] = 'Cannot manage reminders: Task is completed.';
        }

        // --- Delete Task ---
        obj["disableDeleteTask"] = false;
        obj["disableDeleteTaskTitle"] = '';
        if (obj.taskTypeCode?.toUpperCase() == 'DISBURSEMENTS' && this.userrole.includes('ADMIN')) {
          obj['disableDeleteTask'] = false;
          obj['disableDeleteTaskTitle'] = '';
          const isDisbursementTaskApproved = obj.statusCode?.toUpperCase() === 'APPROVED';
          const isParentDisbTaskApproved= obj.parentDisbursementRelatedTask?.statusCode?.toUpperCase() === 'APPROVED';
          if (isDisbursementTaskApproved && !(this.userrole.includes('ADMIN'))) {
            obj['disableDeleteTask'] = true;
            obj['disableDeleteTaskTitle'] = 'Cannot delete: Disbursement Task is approved.';
          } 
          // else if(isParentDisbTaskApproved) {
          //   obj['disableDeleteTask'] = true;
          //   obj['disableDeleteTaskTitle'] = 'Cannot delete: Parent Disbursement Related Task is approved.';
          // } 
          // if (obj.datePaid || obj.disbursementAmount) {
          //   obj['disableDeleteTask'] = true;
          //   obj['disableDeleteTaskTitle'] = 'Cannot delete: Disbursement Task has payment details.';
          // }
        }

        // if (obj.taskTypeCode?.toUpperCase() == 'DISBURSEMENTS' && !this.userrole.includes('ADMIN')) {
        //   obj['disableDeleteTask'] = true;
        //   obj['disableDeleteTaskTitle'] = 'Cannot delete: Disbursement Task.';
        // }

        // if (obj.disbursementRelated?.toUpperCase() == 'YES' && (!this.userrole.includes('ADMIN'))) {
        //   obj['disableDeleteTask'] = true;
        //   obj['disableDeleteTaskTitle'] = 'Cannot delete: Disbursement Related Tasks.';
        // }

        if (obj.isPreInvoiced == "Yes" && obj.projectSubmitToBilling == 'Yes') {
          obj["disableDeleteTask"] = true;
          obj["disableDeleteTaskTitle"] = 'Cannot delete: Pre-invoiced and submitted to billing.';
        }

        if (obj.isCompleted == "Yes") {
          obj['disableDeleteTask'] = true;
          obj['disableDeleteTaskTitle'] = 'Cannot delete: Task is completed.';
        }

        // --- Disbursement Related Task Deletion Logic ---
        if (obj.disbursementRelated?.toUpperCase() === 'YES') {
          // Check if the disbursement-related task is approved
          const isTaskApproved = obj.statusCode?.toUpperCase() === 'APPROVED';
        
          // Check if any associated disbursement task is approved or completed
          let anyDisbursementTaskCompleted = false;
          if (Array.isArray(obj.disbursementTasks)) {
            anyDisbursementTaskCompleted = obj.disbursementTasks.some((d: any) => {
              const isCompleted = d.disbursementTask?.isCompleted?.toUpperCase() === 'YES';
              return isCompleted;
            });
          }
        
          // Allow deletion only if NOT approved and NO associated task is approved or completed
          if (isTaskApproved && !(this.userrole.includes('ADMIN'))) {
            obj['disableDeleteTask'] = true;
            obj['disableDeleteTaskTitle'] = 'Cannot delete: Disbursement Related Task is approved.';
          } 

          if(anyDisbursementTaskCompleted){
            obj['disableDeleteTask'] = true;
            obj['disableDeleteTaskTitle'] = 'Cannot delete: Associated Disbursement Task is completed.';
          }

        }

        if (obj.isCompleted?.toUpperCase() == 'YES' && obj.disbursementRelated?.toUpperCase() == 'YES') {
          obj['disableDeleteTask'] = true;
          obj['disableDeleteTaskTitle'] = 'Cannot delete: Disbursement Related Task is completed.';
        }

        // if (obj.statusCode?.toUpperCase() == 'FOR APPROVAL') {
        //   obj['disableDeleteTask'] = true;
        //   obj['disableDeleteTaskTitle'] = 'Cannot delete: Task is For Approval.';
        // }


        if (obj.statusCode?.toUpperCase() == 'APPROVED' && !(this.userrole.includes('ADMIN') )) {
          obj['disableDeleteTask'] = true;
          obj['disableDeleteTaskTitle'] = 'Cannot delete: Task is approved.';
        }

        if (obj.projectClosedDate && this.filterService.isPastDate(new Date(obj.projectClosedDate))) {
          obj['disableDeleteTask'] = true;
          obj['disableDeleteTaskTitle'] = 'Cannot delete: Project is closed.';
        }

        // --- Clone Task ---
        obj["disableCloneTask"] = true;
        obj["disableCloneTaskTitle"] = 'Cloning not allowed by default.';
        if (this.userrole.includes('LPC') || this.userrole.includes('ADMIN')) {
          obj["disableCloneTask"] = false;
          obj["disableCloneTaskTitle"] = '';
        }
        if (obj.isPreInvoiced == "Yes" && obj.projectSubmitToBilling == 'Yes') {
          obj["disableCloneTask"] = true;
          obj["disableCloneTaskTitle"] = 'Cannot clone: Pre-invoiced and submitted to billing.';
        }
        if (obj.projectClosedDate && this.filterService.isPastDate(new Date(obj.projectClosedDate))) {
          obj['disableCloneTask'] = true;
          obj['disableCloneTaskTitle'] = 'Cannot clone: Project is closed.';
        }
        // Disable clone for Disbursement tasks 
        if (obj.taskTypeCode?.toUpperCase() == 'DISBURSEMENTS') {
          obj['disableCloneTask'] = true;
          obj['disableCloneTaskTitle'] = 'Cannot clone: Task is Disbursements.';
        }

        // --- Add TR Task ---
        obj["disableAddTRTask"] = false;
        obj["disableAddTRTaskTitle"] = '';
        if (obj.statusCode?.toUpperCase() != 'ACCEPTED' && obj.statusCode?.toUpperCase() != 'REJECTED') {
          obj["disableAddTRTask"] = true;
          obj["disableAddTRTaskTitle"] = 'Cannot add time record: Task is not accepted, rejected.';
        }
        if (obj.projectClosedDate && this.filterService.isPastDate(new Date(obj.projectClosedDate))) {
          obj['disableAddTRTask'] = true;
          obj['disableAddTRTaskTitle'] = 'Cannot add time record: Project is closed.';
        }
        if (obj.taskTypeCode?.toUpperCase() == 'DISBURSEMENTS') {
          obj['disableAddTRTask'] = true;
          obj['disableAddTRTaskTitle'] = 'Cannot add time record: Task is Disbursements.';
        }

        // --- For Approval ---
        obj["disableForApproval"] = false;
        obj["disableForApprovalTitle"] = '';
        if (obj.statusCode?.toUpperCase() !== 'FOR APPROVAL') {
          obj['disableForApproval'] = true;
          obj['disableForApprovalTitle'] = "Cannot send for approval: Status is not 'For Approval'.";
        } else if (obj.approver === this.loggedInId || this.userrole.includes("ADMIN")) {
          obj['disableForApproval'] = false;
          obj['disableForApprovalTitle'] = '';
        } else {
          obj['disableForApproval'] = true;
          obj['disableForApprovalTitle'] = 'Cannot send for approval: You are not the approver.';
        }
        if (obj.projectClosedDate && this.filterService.isPastDate(new Date(obj.projectClosedDate))) {
          obj['disableForApproval'] = true;
          obj['disableForApprovalTitle'] = 'Cannot send for approval: Project is closed.';
        }

        // --- Show/Hide Buttons (unchanged logic, but you can add titles if needed) ---
        obj["showAssignTask"] = this.lpcdashboard || (!this.tkdashboard && !this.onlytk);
        obj["showAddTRTask"] = this.onlytk || this.tkdashboard;
        obj["showAcceptRejectTask"] = this.onlytk || this.tkdashboard;

        // --- Ensure all title fields are set (even if empty) ---
        obj["disableAssignTaskTitle"] = obj["disableAssignTaskTitle"] || '';
        obj["disableEditTaskTitle"] = obj["disableEditTaskTitle"] || '';
        obj["disableDeleteTaskTitle"] = obj["disableDeleteTaskTitle"] || '';
        obj["disableCloneTaskTitle"] = obj["disableCloneTaskTitle"] || '';
        obj["disableAddTRTaskTitle"] = obj["disableAddTRTaskTitle"] || '';
        obj["disableForApprovalTitle"] = obj["disableForApprovalTitle"] || '';
        obj["dbStatusCode"] = obj.statusCode ? obj.statusCode.toUpperCase() : '';
        obj["disbursementTasks"] = obj.disbursementTasks ? obj.disbursementTasks.map((d: any) => d.disbursementTask) : [];
        obj["datePaid"] = obj.datePaid ? this.datePipe.transform(obj.datePaid, "MM/dd/yyyy") : '';
        // obj["dateSettled"] = obj.dateSettled ? this.datePipe.transform(obj.dateSettled, "MM/dd/yyyy") : '';
        obj["disbursementRelated"] = obj.disbursementRelated ? obj.disbursementRelated : 'No';
        obj["transactionType"] = obj.transactionType ? obj.transactionType : obj.prefDisbursementType;
        obj["paymentMethod"] = obj.disbursementPayment?.id;
        obj["payee"] = obj.payeeVendor?.id;
        obj['parentDisbursementId'] = obj.parentDisbursementId ? obj.parentDisbursementId : '';
        obj['escrowAccountId'] = obj.escrowAccountId ? obj.escrowAccountId : '';
        obj['dbConsolidatedTR'] = obj.consolidatedTimeRecords ? obj.consolidatedTimeRecords : 'No';
        obj['consolidatedTimeRecords'] = obj.consolidatedTimeRecords ? obj.consolidatedTimeRecords : 'No';
        obj['openEnded'] = obj.openEnded ? obj.openEnded : 'No';
        obj['isApprovalRequired'] = obj.isApprovalRequired ? obj.isApprovalRequired : 'No';
        obj['isRequireEstimate'] = obj.isRequireEstimate ? obj.isRequireEstimate : 'No';
        obj['dueDateChangeCount']=1;
        obj['assignmentStatusChangeCount']=1;
        obj['completedChangeCount']=1;
        obj['statusChangeCount']=1;
      });
      this.loading = false;
      this.totalRecords = res.customValues.totalNumberOfRecords;
      if(this.notifyTaskIdPayload && this.tasks.length > 0 && this.notifyTaskIdPayload.openAddTRDialog){
        if(this.tasks[0].showAddTRTask && !this.tasks[0].disableAddTRTask){ 
          this.openAddTR(this.tasks[0]);
        }
      }

      // Check if we need to open comments for a specific task from notification
      this.handleNotificationNavigation();
    }, res => {
      this.loading = false;
      this.tasks = []
      this.gridErrorMessage = res?.error?.message && res?.error?.status != 500 ? res.error.message : "Error while fetching Data..!";
    })
  }
  getTkPracticeArea() {
    this.userservice.getPracticeArea().subscribe(res => {
      console.log("res", res)
      this.userTkPracticeAreas = res.data;
    })
    // return areas;
  }


  cloneTask(task: any) {
    this.loading = true;
    this.taskService.cloneTask(task.id).subscribe(res => {
      this.loading = false;
      this.editTask(res.data);
      this.loadTasksData(this.lastTableLazyLoadEvent);
      if (this.projTasksFilter) this.tasksChanged.emit();
    })
  }

  private normalizeQuantityStateValues(value: any): string[] {
    const items = Array.isArray(value)
      ? value
      : typeof value === 'string'
        ? value.split(',')
        : [];

    return items
      .map((item: any) => {
        if (typeof item === 'string') return item.trim();
        return String(item?.stateCode ?? item?.value ?? '').trim();
      })
      .filter((stateCode: string, index: number, values: string[]) =>
        !!stateCode && values.indexOf(stateCode) === index
      );
  }

  taskIdCopied = false;

  copyTaskId(id: any): void {
    if (!id) return;
    Promise.resolve().then(() => navigator.clipboard.writeText(String(id))).then(() => {
      this.taskIdCopied = true;
      setTimeout(() => this.taskIdCopied = false, 2000);
    }, () => { });
  }

  viewTask(task: any, tabView: Boolean = false) {
    this.currentTaskRow = task;
    if (!tabView) {
      this.taskDialog = true;
    }else{
      this.selectedTask = task;
      this.showProjectsView = true;
      this.viewTaskName = task.taskName + " [Task ID: "+ task.id +"]";
        this.taskForm.enable();
    }
    this.viewOnly = true;
    task.taskDueDate = this.datePipe.transform(task.taskDueDate, "MM/dd/yyyy");
    if (task.quantityType == "State") {
      this.showQuantityState = true;
      task.quantityState = this.normalizeQuantityStateValues(task.quantityState);
    } else {
      this.showQuantityState = false;
    }

    if (task.countryRelated == "Yes") {
      task.country = task.country ? task.country : "United States";
    }
    // task.driveLink="aerfnaeurbairbpaierbfaebfaehbaeibaernaej";
    task.timeEstimate = this.filterService.convertTimeToDate(task.timeEstimate);
    task.maxTime = this.filterService.convertTimeToDate(task.maxTime);
    this.taskForm.patchValue(task);
    this.taskForm.controls['timeEstimate'].setValue(task.timeEstimate);
    this.taskForm.controls['maxTime'].setValue(task.maxTime);
    this.taskForm.disable();
    if (task.isStateRelated != "Yes") {
      this.taskForm.controls['stateCode'].disable()
      this.showStateCode = false;
    }
    if (task.countryRelated != "Yes") {
      this.taskForm.controls['country'].disable()
      this.showCountry = false;
    }
    if (this.taskForm.getRawValue().taskTypeCode?.toUpperCase() == 'DISBURSEMENTS') {
      this.disbursementTaskDialog = true;
    }
    else {
      this.disbursementTaskDialog = false;
    }

    if (this.taskForm.getRawValue().disbursementRelated?.toUpperCase() == 'YES') {
      if (task.isCompleted?.toUpperCase() == 'YES') {
        this.manageDisbursementsEnabled = false;
      } else {
        this.manageDisbursementsEnabled = true;
      }
      this.manageDisbursementsBtn = true;
    }
    else {
      this.manageDisbursementsBtn = false;
      this.manageDisbursementsEnabled = false;
    }

    this.paymentMethodsList = this.dbPaymentMethodsList;

    this.taskForm.patchValue({ paymentMethod: task.paymentMethod ? task.paymentMethod : '' });
    this.taskForm.patchValue({ escrowAccountId: task.escrowAccountId ? task.escrowAccountId : '' });

    this.title = "View Task : [Task Id : " + task.id + "]";
    this.markTaskFormPristine();

  }

  controlactions() {
    if (this.filterService.isOnlyTKUser(this.userrole)) {
      this.onlytk = true;
      return;
    }
    if (this.userrole.includes("LPC") || this.userrole.includes("ADMIN")) {
      if (this.userrole.includes("TK")) {
        this.combroles = true;
      }
      else {
        this.onlylpcadmin = true;
      }
    }

  }

  async getLoginUserMail(): Promise<void> {
    if(this.loggedInId) return;
    try {
        const res: any = await this.userservice.getLoginUser().toPromise();
        this.loggedInId = res?.rows?.id ;
    } catch (error) {
        console.error("Error fetching login user details:", error);
    }
}

  checkPastDue(date: any, status: any) {
    if (!date)
      return false;
    date = new Date(date);
    let x = date && (date < this.today) && (status != 'Approved') ? true : false;
    return x;
  }
  isValidDueDate() {

    let projectDueDate = new Date(this.taskForm.controls['projectDueDate'].value);
    let createdOn = new Date(this.taskForm.controls['createdOn'].value);
    let taskDueDate = new Date(this.taskForm.controls['taskDueDate'].value);
    if (projectDueDate && createdOn && this.filterService.compareDate(taskDueDate, createdOn) == -1) {
      this.dueDateError = true;
      this.taskForm.controls['taskDueDate'].setErrors({ 'incorrect': true });
      return false;

    }
    else {
      this.dueDateError = false;
      this.taskForm.controls['taskDueDate'].setErrors(null);
      return true;
    }
  }
  dateContains(date: any, minDate: any, maxDate: any) {
    if (date.getTime() >= minDate.getTime() && date.getTime() <= maxDate.getTime()) {
      return true;
    } else {
      return false;
    }
  }

  editTask(task: any, tabView: Boolean = false) {
    this.currentTaskRow = task;
    this.loading = true;
    let payload = { "filters": [{ "field": "qbTaskId", "operator": "contains", "value": task.qbTaskId }], "sort": [] }
    this.taskCatalogue.getCatList(1, 10, payload).subscribe(res => {
      this.catalogueRecord = res?.data?.filter((row: any) => row.isActive?.toUpperCase() == 'ACTIVE')
      if (this.catalogueRecord?.length == 0) {
        this.viewTask(task,tabView)
        this.title = 'Edit Task: [Task Id : ' + task.id + ']';
        setTimeout(() => {
          console.log("Errr")
          this.scrollToTopDialog();
          this.messageService.add({ severity: 'error', detail: "This task in Task Catalogue is In-Active with Quickbook ID :" + task.qbTaskId });
        }, 100);
        return;
      } else {
        this.catalogueRecord = this.catalogueRecord[0]
        task['catEnforceMax'] = this.catalogueRecord.enforceMax;
      }
      this.loading = true;
      if (!tabView) {
        this.taskDialog = true;
      }else{
        this.selectedTask = task;
        this.showProjectsView = true;
        this.viewTaskName = task.projectName;
        this.taskForm.enable();
      }
      this.viewOnly = false;
      this.title = "Edit Task : [Task Id : " + task.id + "]";
      const stateControl = this.taskForm.get('quantityState');
      const numberControl = this.taskForm.get('quantityNumber');
      task.isBillable = this.filterService.getStrBoolean(task.isBillable);
      task.includeToday = this.filterService.getStrBoolean(task.includeToday);


      if (task.quantityType == "State") {
        this.showQuantityState = true;
        if (task.quantityRelated == 'Yes') {
          stateControl.setValidators([Validators.required]);
          this.clearFormValidation('quantityNumber')
        } else {
          this.clearFormValidation('quantityState')
          this.clearFormValidation('quantityNumber')
        }
        task.quantityState = this.normalizeQuantityStateValues(task.quantityState);
      } else {
        if (task.quantityRelated == 'Yes') {
          numberControl.setValidators([Validators.required]);
          this.clearFormValidation('quantityState')
        } else {
          this.clearFormValidation('quantityState')
          this.clearFormValidation('quantityNumber')
        }
        this.showQuantityState = false;
      }

      task.taskDueDate = task.taskDueDate ? this.datePipe.transform(task.taskDueDate, "MM/dd/yyyy") : this.datePipe.transform(task.projectDueDate, "MM/dd/yyyy");
      task.createdOn = task.createdOn ? this.datePipe.transform(task.createdOn, "MM/dd/yyyy") : new Date();
      task.projectDueDate = task.projectDueDate ? this.datePipe.transform(task.projectDueDate, "MM/dd/yyyy") : null;
      task.isStateRelated = task.isStateRelated && typeof (task.isStateRelated) == 'string' && task.isStateRelated.toUpperCase() == 'YES' ? task.isStateRelated : "No";
      task.countryRelated = task.countryRelated && typeof (task.countryRelated) == 'string' && task.countryRelated.toUpperCase() == 'YES' ? task.countryRelated : "No";
      if (task.projectIsBillable && task.projectIsBillable == 'No') {
        task.isBillable = 'No'
      }
      task.isBillable = task.isBillable && typeof (task.isBillable) == 'string' && task.isBillable.toUpperCase() == 'YES' ? task.isBillable : "No";
      task.country = task.country ? task.country : "United States";
      // Ensure entityRelated has a value (default to empty string if undefined)
      task.entityRelated = task.entityRelated || '';
      console.log('editTask - task data before patchValue:', { entityRelated: task.entityRelated, taskId: task.id });
      this.taskForm.patchValue(task);
      console.log('editTask - entityRelated after patchValue:', this.taskForm.get('entityRelated')?.value);
      // Recalculate cached entity related flag
      this._isEntityRelatedTask = this.calculateIsEntityRelatedTask();
      this.taskForm.enable();
      this.taskForm.controls['timeEstimate'].value = this.filterService.convertTimeToDate(task.timeEstimate);
      this.taskForm.controls['maxTime'].value = this.filterService.convertTimeToDate(task.maxTime);
      this.consolidatedTimeRecordsChange(task.consolidatedTimeRecords, task.holdTimeUntilComp);
      this.disableTaskOptionalFields()

      if (task.isStateRelated != "Yes") {
        this.taskForm.controls['stateCode'].disable()
        this.showStateCode = false;
      }
      if (task.countryRelated != "Yes") {
        this.taskForm.controls['country'].disable()
        this.showCountry = false;
      }
      if (!task.quantityType) {
        this.taskForm.controls['quantityState'].disable()
        this.taskForm.controls['quantityNumber'].disable()
      }

      if (task.isApprovalRequired == 'Yes') {
        this.taskForm.get('approver').setValidators([Validators.required]);
      } else {
        this.clearFormValidation('approver')
      }
      if (!(this.userrole.includes('ADMIN')||this.userrole.includes('LPC'))) {//SKIP THIS BLOCK FOR ADMIN USER
        if (task.statusCode?.toUpperCase() == 'ACCEPTED' || task.statusCode?.toUpperCase() == 'FOR APPROVAL' || task.statusCode?.toUpperCase() == 'READY TO COMPLETE') {//Not ADMIN
          this.taskForm.disable();
          if (!this.tkdashboard && !this.onlytk) {//DON'T ALLOW TK TO EDIT TK RATING AND DUE DATE
            // this.taskForm.get('isCompleted').setValidators([Validators.required]);
            if (task.isCompleted == 'No' || !task.isCompleted) {
              this.tkRatingMand = false;
              this.taskForm.controls['taskDueDate'].enable();
              this.taskForm.get('taskDueDate').setValidators([Validators.required]);
              this.taskForm.controls['tkRating'].disable();
              this.clearFormValidation('tkRating')
            }
            else if (task.isCompleted == 'Yes') {
              this.tkRatingMand = true;
              this.taskForm.controls['tkRating'].enable();
              this.taskForm.get('tkRating').setValidators([Validators.required]);
              this.taskForm.get('tkRating').updateValueAndValidity();
            }
          }
        } else {
          this.clearFormValidation('isCompleted');
        }
      }
      this.taskForm.get('isCompleted').disable();
      if ((this.userrole.includes('ADMIN') || this.userrole.includes('LPC')) && (!this.tkdashboard && !this.onlytk)) {//enable only for LPC and ADMIN
        if (!this.taskAssignDialog && (this.taskForm.get('statusCode').value?.toUpperCase() == 'APPROVED')) {
          this.taskForm.get('isCompleted').enable();
        }
        if (task.isCompleted == 'Yes') {
          this.tkRatingMand = true;
          this.taskForm.controls['tkRating'].enable();
          this.taskForm.get('tkRating').setValidators([Validators.required]);
          this.taskForm.get('tkRating').updateValueAndValidity();
        } else {
          this.tkRatingMand = false;
          this.taskForm.controls['tkRating'].disable();
          this.clearFormValidation('tkRating')
        }
        this.lpcAccepAssignFields(task)
      }
      this.onEnforceMaxChange();
      if (task.projectHoldTimeUntilCompleted && task.projectHoldTimeUntilCompleted == 'Yes') {
        this.taskForm.controls['holdTimeUntilComp'].disable();
      }
      if (this.userrole.includes('Billing') && this.userrole.length == 1) {//
        // Check if project is editable
        this.taskForm.disable();
        if (task.isPreInvoiced === 'Yes') {
          // Enable editing of specific task fields&& task.projectSubmitToBilling === 'Yes' && task.projectIsInvoicePaid === 'Yes' //&& task.projectSubmitToBilling === 'Yes' && task.projectIsInvoicePaid === 'Yes'
          this.taskForm.get('notes').enable();
          this.taskForm.get('description').enable();
          this.taskForm.get('taskDueDate').enable();
          this.taskForm.get('reviewStatus').enable();
        }
      }
      if (this.taskForm.getRawValue().disbursementRelated?.toUpperCase() == 'YES') {
        if (task.isCompleted?.toUpperCase() == 'YES') {
          this.manageDisbursementsEnabled = false;
        } else {
          this.manageDisbursementsEnabled = true;
        }
        this.manageDisbursementsBtn = true;
      }
      else {
        this.manageDisbursementsBtn = false;
        this.manageDisbursementsEnabled = false;
      }

      if (this.taskForm.getRawValue().taskTypeCode?.toUpperCase() == 'DISBURSEMENTS') {
        this.disbursementTaskDialog = true;
        this.clearFormValidation('holdTimeUntilComp');
        this.taskForm.controls['isRequireEstimate'].value = 'No';
        this.taskForm.controls['openEnded'].value = 'No';
        this.taskForm.controls['isApprovalRequired'].value = 'No';
        this.taskForm.controls['isBillable'].value = 'Yes';
        this.taskForm.controls['isBillable'].disable();
        this.clearFormValidation('consolidatedTimeRecords');
        this.clearFormValidation('timeEstimate');
        this.clearFormValidation('isRequireEstimate');
        this.clearFormValidation('openEnded');
        this.clearFormValidation('isApprovalRequired');
        this.clearFormValidation('tkRating');
        this.clearFormValidation('nonBillableReason');
        this.taskForm.controls['tkRating'].setValue(0);
        if (this.onlytk) {
          if(task.isCompleted?.toUpperCase() != 'YES'&& (task.statusCode?.toUpperCase() != 'APPROVED' && task.statusCode?.toUpperCase() != 'ASSIGNED')){
            this.disPaymentCompletedEnabled = true;
          }
          this.taskForm.disable();
          this.taskForm.get('paymentMethod').enable();
          this.taskForm.get('escrowAccountId').enable();
          this.taskForm.get('payee').enable();
          this.taskForm.get('datePaid').enable();
          this.taskForm.get('disbursementAmount').enable();
          this.taskForm.get('payeeInvoiceNumber').enable();
          this.taskForm.get('paymentReferenceNumber').enable();
          this.taskForm.get('receipt').enable();
        }
        if (task.isPreInvoiced?.toUpperCase() == "YES") {
          this.taskForm.controls['transactionType'].value = 'Pre-Invoiced';
          task.transactionType = 'Pre-Invoiced';
          // this.taskForm.controls['transactionType'].disable();
          this.taskForm.clearValidators();
          this.taskForm.updateValueAndValidity();
          this.taskForm.get('disbursementAmount').setValidators([Validators.required]);
        } 
        if (((this.onlytk) || (this.userrole.includes('TK') && !this.onlytk && this.tkdashboard))) {//validate only for TK when in TK dashboard or only TK user
           if(task.isCompleted?.toUpperCase() != 'YES' && task.statusCode?.toUpperCase() != 'APPROVED' && task.statusCode?.toUpperCase() != 'ASSIGNED'){
            this.disPaymentCompletedEnabled = true;
          }
          // this.taskForm.get('paymentMethod').setValidators([Validators.required]);
          this.taskForm.get('payee').setValidators([Validators.required]);
          this.taskForm.get('datePaid').setValidators([Validators.required]);
          this.taskForm.get('disbursementAmount').setValidators([Validators.required, Validators.min(0.01)]);
        }

        if (task.transactionType?.toUpperCase() === "CREDIT CARD ON FILE") {
          this.clearFormValidation('paymentMethod');
          this.taskForm.patchValue({ paymentMethod: '' });
          this.taskForm.get('paymentMethod').disable();
        } else {
          this.taskForm.get('paymentMethod').enable();
          this.clearFormValidation('paymentMethod');
          this.taskForm.updateValueAndValidity();
          if (task.isPreInvoiced?.toUpperCase() != "YES") {
            this.taskForm.get('paymentMethod').setValidators([Validators.required]);
            this.taskForm.get('paymentMethod').updateValueAndValidity();
          }
        }
      }
      else {
        this.clearFormValidation('disbursementAmount');
        this.disbursementTaskDialog = false;
      }

      if (task.isBillable === 'No') {
        this.taskForm.get('nonBillableReason')?.enable();
        this.taskForm.get('nonBillableReason')?.setValidators([Validators.required]);
        this.taskForm.get('nonBillableReason')?.updateValueAndValidity();
      } else {
        // this.taskForm.get('nonBillableReason')?.clearValidators();
        // this.taskForm.get('nonBillableReason')?.updateValueAndValidity();
         this.taskForm.get('nonBillableReason')?.disable();
        this.clearFormValidation('nonBillableReason');
      }
      if (this.onlytk) {
        this.taskForm.get('nonBillableReason')?.disable();
        this.clearFormValidation('nonBillableReason');
      }
      if (this.taskForm.getRawValue().taskTypeCode?.toUpperCase() == 'DISBURSEMENTS') {
        if(this.taskForm.getRawValue().statusCode?.toUpperCase() =="READY TO COMPLETE" && (this.userrole.includes('LPC') || this.userrole.includes('ADMIN'))){
          this.taskForm.get('isCompleted').enable();
        }
        this.clearFormValidation('nonBillableReason');
      }
      this.taskForm.get('orgNotes')?.disable();

      this.paymentMethodsList = this.dbPaymentMethodsList;

      this.taskForm.patchValue({ paymentMethod: task.paymentMethod ? task.paymentMethod : '' });
      this.taskForm.patchValue({ escrowAccountId: task.escrowAccountId ? task.escrowAccountId : '' });

      // Load entity information if task is entity-related
      const entityId = task.entityId;
      if (entityId) {
        this.entityService.loadEntityForEdit(entityId);
      }
      this.loading = false;
      this.markTaskFormPristine();

    });
  }

  isEditBlocked(): boolean {
    return !!this.currentTaskRow?.disableEditTask;
  }

  canAcceptCurrentDisbursementTask(): boolean {
    return !!this.currentTaskRow
      && this.viewOnly
      && !this.taskAssignDialog
      && this.userrole.includes('TK')
      && (this.onlytk || this.tkdashboard)
      && this.currentTaskRow.taskTypeCode?.toUpperCase() === 'DISBURSEMENTS'
      && this.currentTaskRow.statusCode?.toUpperCase() === 'ASSIGNED'
      && this.currentTaskRow.isCompleted?.toUpperCase() !== 'YES';
  }

  openCurrentTaskAcceptance(): void {
    if (!this.canAcceptCurrentDisbursementTask()) return;
    this.acceptOpenedFromTaskDialog = true;
    this.openAcceptTask(this.currentTaskRow);
  }

  closeAcceptTaskDialog(): void {
    if (!this.acceptOpenedFromTaskDialog) {
      this.closeDialog();
      return;
    }

    this.acceptTaskDialog = false;
    this.acceptOpenedFromTaskDialog = false;
    this.accbtnflag = true;
    this.rejbtnflag = true;
    this.viewOnly = true;
    this.taskForm.patchValue(this.currentTaskRow);
    this.taskForm.disable();
  }

  getEditTaskDisabledReason(): string {
    return this.currentTaskRow?.disableEditTaskTitle || 'This task cannot be edited.';
  }

  switchToEditMode() {
    if (!this.currentTaskRow || this.isEditBlocked()) return;
    this.editTask(this.currentTaskRow);
  }

  markTaskFormPristine() {
    this.taskForm.markAsPristine();
    this.taskForm.markAsUntouched();
  }

  manageDisbursements() {
    // Get the current assigned disbursement tasks for the task
    const task = this.taskForm.getRawValue();
    this.title = "Manage Disbursements  [Task Id : " + task.id + "]";
    // Defensive copy and ensure correct object structure for grid
    this.disbursements = Array.isArray(task.disbursementTasks)
      ? task.disbursementTasks.map((d: any) => ({
        id: d.id,
        taskName: d.taskName || '',
        taskFullName: d.taskFullName || null,
        taskTypeCode: d.taskTypeCode || '',
        practiceAreaCode: d.practiceAreaCode || 0,
        statusCode: d.statusCode || ''
      }))
      : [];
    // Reset tracking arrays
    this.taskForm.patchValue({ newDisbursementTaskIds: [] });
    this.deletedDisbursementTaskIds = [];
    this.manageDisbursementsDialog = true;
  }

  addDisbursement() {
    // Use newDisbursementTaskIds from the form
    // const idsToAdd = (this.taskForm.getRawValue().newDisbursementTaskIds || []).filter(
    //   (id: number) => !this.disbursements.some((d: any) => d.id === id)
    // );
    this.taskForm.getRawValue().newDisbursementTaskIds.forEach((id: number) => {
      const disb = this.allDbDisbursements.find((d: any) => d.id === id);
      if (disb) {
        const disbObj = {
          id: disb.id,
          taskName: disb.taskName || '',
          taskFullName: disb.taskFullName || null,
          taskTypeCode: disb.taskTypeCode || '',
          practiceAreaCode: disb.practiceAreaCode || 0,
          statusCode: "New"
        };
        this.disbursements.push(disbObj);
        // If it was previously marked for deletion, remove from deletedDisbursementTaskIds
        this.deletedDisbursementTaskIds = this.deletedDisbursementTaskIds.filter((delId: number) => delId !== disbObj.id);
      }
    });
  }

  deleteDisbursement(disbursementId: number) {
    // Remove from disbursements
    this.disbursements = this.disbursements.filter((d: any) => d.id !== disbursementId);
    // If it was newly added in this session, remove from newDisbursementTaskIds in the form
    const currentNewIds = this.taskForm.getRawValue().newDisbursementTaskIds || [];
    if (currentNewIds.includes(disbursementId)) {
      this.taskForm.patchValue({
        newDisbursementTaskIds: currentNewIds
      });
    } else {
      // Otherwise, mark for deletion if it was originally assigned
      if (!this.deletedDisbursementTaskIds.includes(disbursementId)) {
        this.deletedDisbursementTaskIds.push(disbursementId);
      }
    }
  }

  saveDisbursements() {
    // Use newDisbursementTaskIds from the form
    // const newIds = this.taskForm.getRawValue().newDisbursementTaskIds || [];
    // if (newIds.length === 0 && this.deletedDisbursementTaskIds.length === 0) {
    //   this.manageDisbursementsDialog = false;
    //   return;
    // }
    console.log(this.disbursements);
    const newIds = this.disbursements.filter((d: any) => d.statusCode === 'New').map((d: any) => d.id);

    const payload = {
      addedTaskIds: newIds,
      deletedTaskIds: this.deletedDisbursementTaskIds
    };
    this.taskService.manageDisbursement(this.taskForm.getRawValue().id, payload).subscribe(
      res => {
        this.taskForm.patchValue({ newDisbursementTaskIds: [] });
        this.deletedDisbursementTaskIds = [];
        this.scrollToTopDialog();
        this.messageService.add({ severity: 'success', detail: "Disbursements Updated successfully!" });
        this.viewOnly = true;
        setTimeout(() => {
          this.closeDialog();
        }, 1000);
      },
      err => {
        this.scrollToTopDialog();
        this.messageService.add({ severity: 'error', detail: "Error while adding disbursement!" });
      }
    );
  }

  BackToeditTask() {
    this.manageDisbursementsDialog = false;
    this.title = "Edit Task: [Task Id : " + this.taskForm.getRawValue().id + "]";
  }

  isStatusInOptions(): boolean {
    const value = this.taskForm?.get('statusCode')?.value;
    return this.statuses.some((status: any) => status.value === value);
  }

  lpcAccepAssignFields(task: any) {
    if (this.filterService.getflagBoolean(task.stateRelated)) {
      this.taskForm.controls['stateCode'].enable();
    }
    this.taskForm.controls['timeEstimate'].enable();
    this.taskForm.controls['maxTime'].enable();
    if (task.projectIsBillable && task.projectIsBillable == 'No') {
      this.clearFormValidation('isBillable');
      this.taskForm.controls['isBillable'].disable();
    } else {
      this.taskForm.controls['isBillable'].enable();
    }
    this.taskForm.controls['consolidatedTimeRecords'].enable();
    this.taskForm.controls['isRequireEstimate'].enable();
    this.taskForm.controls['isApprovalRequired'].enable();
    this.taskForm.controls['taskDueDate'].enable();
    this.taskForm.controls['dueDaySlot'].enable();
    this.taskForm.controls['openEnded'].enable();
    this.taskForm.controls['approver'].enable();
    // this.taskForm.controls['practiceAreaCode'].enable();
    this.taskForm.controls['reviewStatus'].enable();
    this.taskForm.controls['notes'].enable();
    this.taskForm.controls['driveLink'].enable();
    this.taskForm.controls['description'].enable();
  }

  onIsApprovalRequiredChange(event: any) {
    if (event.target.value == 'Yes') {
      this.taskForm.get('approver').setValidators([Validators.required]);
      this.taskForm.get('approver').updateValueAndValidity();
    } else {
      this.clearFormValidation('approver')
    }
    // Mark statusCode as dirty and touched to trigger re-render
    const statusCtrl = this.taskForm.get('statusCode');
    statusCtrl.markAsDirty();
    statusCtrl.markAsTouched();
    // Set its value to itself to force change detection
    statusCtrl.setValue(statusCtrl.value);
    statusCtrl.updateValueAndValidity();
  }
  disableTaskOptionalFields() {

    this.taskForm.controls['qbTaskId'].disable()
    this.taskForm.controls['taskName'].disable()
    this.taskForm.controls['projectName'].disable()
    this.taskForm.controls['rateTypeCode'].disable()
    this.taskForm.controls['isCompleted'].disable()
    this.taskForm.controls['actualTime'].disable()
    this.taskForm.controls['isStateRelated'].disable()
    this.taskForm.controls['rateTypeCode'].disable()
    this.taskForm.controls['countryRelated'].disable()
    // this.taskForm.controls['isEnforceMaximum'].disable()
    this.taskForm.controls['tkRating'].disable()
  }
  closeDialog() {
    if(this.notifyTaskIdPayload?.openAddTRDialog){
      this.notifyTaskIdPayload.openAddTRDialog = false;
    }
    this.cardLoading = false;
    this.viewOnly = false;
    this.taskDialog = false;
    this.taskAssignDialog = false;
    this.assignmentDetailsExpanded = false;
    this.acceptTaskDialog = false;
    this.acceptOpenedFromTaskDialog = false;
    this.addTRDialog = false;
    this.enableDeleteTask = false;
    this.enableReassignTask = false;
    this.submitted = false;
    this.showCountry = true;
    this.showStateCode = true;
    this.viewTaskAssignmentDialog = false;
    this.includeToday = false;
    // Clear entity data when closing Add Time Record dialog
    this.entityService.clearEntityData();
    this.dueDateError = false;
    this.taskAssignedUsers = [];
    this.rejectTimeRecords = false;
    this.deleteTRAR = false;
    this.deleteConfirmationDialog = false;
    this.forApprovalDialog = false;
    this.accbtnflag = true;
    this.rejbtnflag = true;
    this.showConfirmAlert = false;
    this.confirmMessage = "";
    this.confirmMsgCategory = [];
    this.tkRatingMand = false;
    this.disbursementTaskDialog = false;
    this.manageDisbursementsDialog = false;
    this.manageDisbursementsBtn = false;
    this.manageDisbursementsEnabled = false;
    this.disbursements = [];
    this.reminderDialog = false;
    this.entityService.clearEntityData();
    this.entityService.entityDialog = false;
    this.entityService.updateEntityDialog = false;
    this.reminderNotificationDialog = false;
    this.auditDialog = false;
    this.viewTaskName = "";
    this.selectedTask = null;
    this.showProjectsView = false;
    this.disPaymentCompletedEnabled = false;
    this.disPaymentCompletedClicked = false;
    this.skipIsTKUpdatedEntity = false;
    this.basicEntityEditMode = false;
    this.loadTasksData(this.lastTableLazyLoadEvent);
  }

  reloadTasks() {
    this.loadTasksData(this.lastTableLazyLoadEvent);
  }

  openAssignTask(task: any, deleteTask: any = false, reassign: boolean = false) {
    this.openTask = task;
    this.assignmentDetailsExpanded = false;
    this.notesRailCollapsed = false;
    this.enableReassignTask = reassign;
    this.viewTaskAssignmentDialog = false;
    this.loadingTkUsers = true;
    this.tkUsers = [];
    this.filteredTkUsers = [];
    this.viewTask(task);
    this.taskAssignDialog = true;
    this.assignedTkUser = [];
    this.assignedTkUserName = "";

    if (reassign) {

      this.taskService.getTKAssignmentDetails(task.id).subscribe(res => {
        this.assignedTkUserName = task.projTaskAssignmentUsername;
        const activeAssignments = (res.data?.assignments || []).filter((obj: any) => obj.assignmentStatus != "Rejected");
        const normalize = (email: any) => typeof email === "string" ? email.trim().toLowerCase() : "";
        const currentEmail = normalize(this.assignedTkUserName);
        this.assignedTkUser = currentEmail ? activeAssignments.filter((obj: any) => normalize(obj.timekeeper?.mainEmail) === currentEmail) : [];
        this.reassignReason = "";
        this.loadTKUsersGrid(task.id, false, true)

      })
      this.title = "Reassign Task To Time Keeper [Task Id : " + task.id + "]";
    }
    else {

      if (task.statusCode?.toUpperCase() == "OPEN") {
        this.title = "Assign Task To Time Keeper [Task Id : " + task.id + "]";
        this.loadTKUsersGrid(task.id, false)
      } else {
        this.loadingTkUsers = true;
        this.viewTaskAssignmentDialog = true;
        this.taskService.getTKAssignmentDetails(task.id).subscribe(res => {
          this.loadingTkUsers = false;
          this.taskAssignedUsers = res.data.assignments;
          this.taskAssignedUsers.forEach((obj: any) => obj.tkAcceptedTime = this.filterService.convertTimeNumToStr(obj.tkAcceptedTime));
          this.includeToday = res.data.projectTask.includeToday == "NO" ? false : true;
          if (deleteTask) {
            this.title = "Delete Task [Task Id : " + task.id + "]";
          }
          else
            this.title = "View Task Assignments [Task Id : " + task.id + "]";
        })
      }
    }
  }

  loadDayWiseData(taskid: any, statusCode: any) {
    this.loadingDayWiseData = true;
    this.rejectresponse = []
    this.accepteddaywiseData = []
    if (this.lpcdashboard || this.onlylpcadmin) {
      this.taskService.getAcceptedAdmin(taskid).subscribe(res => {
        this.loadingDayWiseData = false;
        let temp = res && res.data.assignments ? res.data.assignments : [];
        for (var i = 0; i < temp.length; i++) {
          var x = temp[i].details
          x['tkMail'] = temp[i].timekeeper.mainEmail
          x['tkId'] = temp[i].timekeeper.id
          x['projTaskId'] = res.data.projTask.id
          this.accepteddaywiseData.push(x)
        }

      })
    }
    else {
      if (statusCode?.toUpperCase() == "ASSIGNED") {
        this.taskService.getDayWiseData(taskid).subscribe(res => {
          this.loadingDayWiseData = false;
          this.daywiseData = res && res.data ? res.data : [];
          this.assignedTime = this.daywiseData[0] ? this.daywiseData[0].assignedTime : 0;
          this.daywiseData.map((obj: any) => {
            obj['timelist'] = this.timeSlot;
            // .slice(0, obj.availableTime / 30);
            obj['minutes'] = this.filterService.convertTimeToDate(obj['minutes']);
            obj['date'] = obj.availableDate;
            obj['projTaskId'] = this.acceptDdata.id;
            obj['availableTime'] = this.filterService.convertTimeNumToStr(obj['availableTime']);
            obj['maxAcceptTime'] = this.filterService.convertTimeToDate(this.filterService.convertStrToNum(obj['availableTime']));
          })
        })
      }
      else {
        this.taskService.getAcceptedDaywise(taskid).subscribe(res => {
          this.loadingDayWiseData = false;
          this.accepteddaywiseData = res && res.data && res.data.assignments && res.data.assignments && res.data.assignments[0] ? res.data.assignments[0].acceptance : [];
          this.accepteddaywiseData.map((obj: any) => {
            obj['tkMail'] = res.data.assignments[0].timekeeper.mainEmail
            obj['projTaskId'] = this.acceptDdata.id
            obj['tkUserId'] = res.data.assignments[0].timekeeper.id
            obj['minutes'] = this.filterService.convertTimeToDate(obj['minutes']);
            obj['availableTime'] = this.filterService.convertTimeNumToStr(obj['availableTime']);
            obj['maxAcceptTime'] = this.filterService.convertTimeToDate(this.filterService.convertStrToNum(obj['availableTime']));
          })
        })
      }
    }
  }

  forApprovalChange(event: any, day: any) {

    if (event.target.checked)
      this.rejectresponse.push(day)
    else
      this.rejectresponse = this.rejectresponse.filter((item: any) => item.tkId !== day.tkId);

  }

  onReassignReasonChange(reason: any) {
    this.reassignReason = reason;
    if (reason)
      this.disableReassignbtnFlag = false;
    else
      this.disableReassignbtnFlag = true;
  }

  onDeleteReasonChange(reason: any) {
    this.deleteReason = reason;
    if (reason)
      this.disableDelbtnFlag = false;
    else
      this.disableDelbtnFlag = true;
  }

  openAcceptTask(task: any) {
    this.acceptTaskDialog = true;
    this.title = "Accept/Reject Task [Task Id : " + task.id + "]";
    this.acceptDdata = task;
    this.acceptDdata.includeToday = task.includeToday == "YES" ? true : false;
    task.estimatehours = this.acceptDdata.timeEstimate;
    this.taskForm.patchValue(task);
    this.taskForm.controls['timeEstimate'].value = this.filterService.convertTimeToDate(task.timeEstimate);
    this.taskForm.controls['maxTime'].value = this.filterService.convertTimeToDate(task.maxTime);
    this.taskForm.disable();
    // if (task.isRequireEstimate == 'Yes' && task.statusCode == "Assigned") {
    //   this.taskForm.controls['timeEstimate'].enable();
    // }
    if (this.acceptDdata.statusCode?.toUpperCase() != 'ASSIGNED') {
      this.accbtnflag = false;
    }
    if (this.acceptDdata.statusCode?.toUpperCase() == 'APPROVED') {
      this.rejbtnflag = false;
    }
    this.loadDayWiseData(task.id, task.statusCode)

  }
  openAddTR(task: any, deleteTask: any = false) {
    this.timeRecords = []
    this.hasDuplicateTR = false;
    this.addTRDialog = true;
    task.isBillable = this.filterService.getflagBoolean(task.isBillable);
    task.taskReadyToComplete = task.isCompleted == "Yes" || task.statusCode?.toUpperCase() == "READY TO COMPLETE" ? true : this.filterService.getflagBoolean(task.taskReadyToComplete);
    task.includeToday = this.filterService.getflagBoolean(task.includeToday);
    task.timeEstimate = this.filterService.convertTimeToDate(task.timeEstimate);
    task.maxTime = this.filterService.convertTimeToDate(task.maxTime);
    this.timeRecordsDueDate = new Date(task.taskDueDate);
    this.timeRecordsStartDate = task.projectStartDate ? new Date(task.projectStartDate) : null;
    task.timeRecordsLoggedTime = this.filterService.convertTimeToDate(task.timeRecordsLoggedTime);
    // Ensure entityRelated has a value (default to empty string if undefined)
    task.entityRelated = task.entityRelated || '';
    console.log('openAddTR - entityRelated value:', task.entityRelated, 'entityId:', task.entityId);
    this.taskForm.patchValue(task);
    // this.taskForm.controls['isCompleted'].value = task.isCompleted == "Yes" ? true : false;
    // this.taskForm.controls['isBillable'].value = task.isBillable == "Yes" ? true : false;
    this.taskForm.controls['isEnforceMaximum'].value = this.taskForm.controls['isEnforceMaximum'].value ? this.taskForm.controls['isEnforceMaximum'].value : 'No';
    this.taskForm.disable();
    if (task.isCompleted != "Yes") {
      // Only enable taskReadyToComplete if entity info is complete (for entity-related tasks)
      if (this.isEntityRelatedTask && !this.isEntityInfoComplete()) {
        this.taskForm.controls['taskReadyToComplete'].disable();
      } else {
        this.taskForm.controls['taskReadyToComplete'].enable();
      }
    }

    if (task.projectIsBillable && task.projectIsBillable == 'No') {
      this.clearFormValidation('isBillable');
      this.taskForm.controls['isBillable'].disable();
    } else {
      this.taskForm.controls['isBillable'].enable();
    }

    this.title = "Add Time Record [Task Id : " + task.id + "]";
    this.acceptDdata = task;
    // this.estimatehours=this.acceptDdata.timeEstimate;
    this.disableADDTR = this.taskForm.controls.taskReadyToComplete.value

    // Load entity information for entity-related tasks
    if (task.id) {
      this.loadEntityByTaskId(task.id);
    }

    if (deleteTask) {
      this.title = "Delete Task [Task Id : " + task.id + "]";
      this.taskForm.disable();
      this.disableADDTR = true;
      this.loadTimeRecordData(task.id, true);
      // this.enableDeleteTask = true;
    }
    else {
      this.loadTimeRecordData(task.id);
    }



  }
  loadTimeRecordData(taskId: any, deleteTask: any = false) {
    this.messageService.clear();
    this.loadingData = true;

    this.taskService.getExistingTR(taskId).subscribe(res => {
      this.loadingData = false;
      this.acceptedDates = res.data.acceptedDates;
      this.timeRecords = res.data.timeRecords;
      this.timeRecords.map((obj: any) => {
        // obj["date"] = new Date(obj["date"])
        obj["enteredTime"] = this.filterService.convertTimeToDate(obj["enteredTime"]);
        obj["dateValid"] = true;
        // obj["datefutureValid"] = true;
        obj["descValid"] = true;
        obj["timeValid"] = true;
        obj["disableDel"] = true;
        if (obj["timeRecStatus"] != "In Progress") {
          obj["disableInp"] = true;
        }
        if (deleteTask) {
          obj["disableInp"] = true;
        }
        if (obj["timeRecStatus"] == "Approved") {
          this.isAnyTrApproved = true;
        }
        obj["quantityType"] = this.taskForm.getRawValue().quantityType;
        if (obj["quantityType"] == 'State') {
          obj["quantityStateList"] = obj.quantity ? obj.quantity.split(",") : [];
        } else {
          obj["quantity"] = obj.quantity;
        }
        if (this.taskForm.controls['isPreInvoiced'].value === 'Yes' && this.taskForm.controls['isPrePaid'].value === 'Yes' && this.taskForm.controls['quantityRelated'].value == 'Yes' && this.taskForm.controls['quantityType'].value) {
          obj["disableQuantity"] = true;
        }
      })
      if (this.isAnyTrApproved && deleteTask) {
        const { statusCode, isCompleted } = this.taskForm.getRawValue();
        const status = statusCode?.toUpperCase();
        const completed = isCompleted?.toUpperCase() === "YES";
        
        const isAdmin = this.userrole.includes("ADMIN");
        const isLPC = this.userrole.includes("LPC");

        // 1. Check for ACCEPTED status restrictions
        if (status === "ACCEPTED" && !isAdmin && !isLPC) {
          this.enableDeleteTask = false;
          this.messageService.add({ severity: 'error', detail: "Task cannot be deleted if any Time Records are Approved" });
          return;
        }

        // 2. Check for APPROVED (but not completed) status restrictions
        if (status === "APPROVED" && !completed && !isAdmin) {
          this.enableDeleteTask = false;
          this.messageService.add({ severity: 'error', detail: "Task cannot be deleted if any Time Records are Approved and Task is not Completed" });
          return;
        }

        // 3. Default state if checks pass
        this.enableDeleteTask = true;
      } else if(deleteTask) {
        this.enableDeleteTask = true;
      }

    })
    this.appConfigService.getConfigurationsById(null).subscribe(res => {
      let data = res.data.filter((obj: any) => obj.name == "Time Closing Date");
      let preInvoicedDate = res.data.filter((obj: any) => obj.name == "Preinvoice Launch");
      this.preInvoiceDate = preInvoicedDate.length > 0 && preInvoicedDate[0].value ? new Date(preInvoicedDate[0].value) : new Date();
      const timeclosingDate = new Date(data[0].value);
      const projectStartDate = this.timeRecordsStartDate
      const projectDueDate = this.timeRecordsDueDate
      const today = new Date()
      let trstart = timeclosingDate;
      let trend = projectDueDate;

      if (timeclosingDate.getTime() < projectStartDate.getTime()) {
        trstart = projectStartDate;
      }

      if (projectDueDate.getTime() > today.getTime()) {
        trend = today;
      }
      this.timeRecordsStartDate = trstart
      this.timeRecordsDueDate = trend

    })
  }

  accept() {
    this.messageService.clear();
    var temp = []
    let enteredTime = 0
    let availableTime = 0
    if (this.acceptDdata.taskTypeCode?.toUpperCase() == 'DISBURSEMENTS') {
      temp.push({ "date": this.datePipe.transform(new Date(), "MM/dd/yyyy"), "minutes": 0 })
    }
    else {
      for (var i of this.daywiseData) {
        availableTime += this.filterService.convertStrToNum(i.availableTime)
        if (this.filterService.convertDateToTime(i.minutes) > 0) {
          if (this.acceptDdata.taskTypeCode?.toUpperCase() == 'DISBURSEMENTS') {
            temp.push({ "date": this.datePipe.transform(new Date(), "MM/dd/yyyy"), "minutes": 0 })
          }
          else {
            enteredTime += this.filterService.convertDateToTime(i.minutes)
            temp.push({ "date": i.availableDate, "minutes": this.filterService.convertDateToTime(i.minutes) })
          }
        }
      }
    }

    if (temp.length == 0 && !(this.acceptDdata.taskTypeCode?.toUpperCase() == 'DISBURSEMENTS')) {
      this.scrollToTopDialog();
      this.messageService.add({ severity: 'error', detail: "Please Enter Time to Accept this task. " });
      return;
    }


    if (
        !(this.acceptDdata.taskTypeCode?.toUpperCase() == 'DISBURSEMENTS') &&
        this.acceptDdata.isEnforceMaximum == 'Yes' &&
        this.acceptDdata.openEnded == 'No' &&
        !(
          enteredTime <= availableTime &&
          enteredTime <= this.acceptDdata.maxTime
        )
      )  {
      this.scrollToTopDialog();
      this.messageService.add({ severity: 'error', detail: "You can’t accept this task using the hours you selected because your available time before the task’s due date is already committed to other accepted tasks. The estimated time for this task exceeds your remaining availability during that period. If you’re available to work on this task at another time, try adjusting your estimated time accordingly." });
      return;
    }

    // if (this.acceptDdata.isEnforceMaximum == 'Yes' && (this.acceptDdata.maxTime ? enteredTime > this.acceptDdata.maxTime : enteredTime > this.acceptDdata.timeEstimate)) {
    //   this.messageService.add({ severity: 'error', detail: (this.acceptDdata.maxTime && (enteredTime > this.acceptDdata.maxTime)) ? "Accepted Time Should not Exceed Max Time" : "Accepted Time Should not Exceed Estimated Time" });
    //   return;
    // }

    let payload = {
      "assignments": [{
        "tkId": this.daywiseData[0].tkUserId,
        "projTaskId": this.acceptDdata.id,
        "status": "ACCEPT",
        "timeEstimate": this.filterService.convertDateToTime(this.taskForm.getRawValue().timeEstimate),
        "tkAcceptanceDetails": temp
      }
      ]
    }
    this.taskService.acceptTastbyTK(payload).subscribe(res => {
      if (res.message == "Successful.") {
        this.scrollToTopDialog();
        this.messageService.add({ severity: 'success', detail: "Accepted Successfully!" });
        this.accbtnflag = false;
        if (this.acceptOpenedFromTaskDialog && this.currentTaskRow) {
          this.currentTaskRow.statusCode = 'Accepted';
          this.currentTaskRow.projTaskAssignmentStatus = 'Accepted';
          this.currentTaskRow.disableEditTask = false;
          this.currentTaskRow.disableEditTaskTitle = '';
          this.taskForm.patchValue({ statusCode: 'Accepted' });
          this.acceptTaskDialog = false;
        } else {
          this.closeDialog();
        }
      }
      else {
        this.scrollToTopDialog();
        this.messageService.add({ severity: 'error', detail: res.message });
      }

    }, res => {
      this.scrollToTopDialog();
      this.messageService.add({ severity: 'error', detail: res.error.message });
    })

  }

  reject() {
    this.rejbtnLoading = true;
    this.messageService.clear();
    if ((this.lpcdashboard || (!this.onlytk && !this.tkdashboard))) {
      this.taskService.acceptTastbyTK({ "assignments": this.rejectresponse }).subscribe(res => {//for approval
        if (res.message == "Successful.") {
          this.scrollToTopDialog();
          this.messageService.add({ severity: 'success', detail: "Rejected Successfully!" });
          this.rejbtnLoading = false;
          this.rejbtnflag = false;
        }
        else {
          this.scrollToTopDialog();
          this.messageService.add({ severity: 'error', detail: res.message });
        }
      }, res => {
        this.rejbtnLoading = false;
        this.scrollToTopDialog();
        this.messageService.add({ severity: 'error', detail: res.error.message });
      })
    }
    else {
      if ((!this.daywiseData || this.daywiseData.length == 0) &&
        (!this.accepteddaywiseData || this.accepteddaywiseData.length == 0)) {
        this.rejbtnLoading = false;
        this.scrollToTopDialog();
        this.messageService.add({ severity: 'error', detail: "No Assignments Found to Accept/Reject for the Task" });
        return;
      }
      let payload = {
        "assignments": [{
          "tkId": this.daywiseData ? this.daywiseData[0].tkUserId : this.accepteddaywiseData[0].tkUserId,
          "projTaskId": this.acceptDdata.id,
          "status": "REJECT",
        }]
      }
      this.taskService.acceptTastbyTK(payload).subscribe(res => {
        if (res.message == "Successful.") {
          this.scrollToTopDialog();
          this.messageService.add({ severity: 'success', detail: "Rejected Successfully!" });
          this.rejbtnLoading = false;
          this.rejbtnflag = false;
          this.closeDialog();
        }
        else {
          this.rejbtnLoading = false;
          this.scrollToTopDialog();
          this.messageService.add({ severity: 'error', detail: res.message });
        }
      }, res => {
        this.rejbtnLoading = false;
        this.scrollToTopDialog();
        this.messageService.add({ severity: 'error', detail: res.error.message });
      })
    }

  }

  applyTkFilter() {
    const term = (this.tkSearchTerm || '').trim().toLowerCase();
    const list = this.tkUsers || [];
    this.filteredTkUsers = term
      ? list.filter((u: any) =>
          ((u.tkFirstName || '') + ' ' + (u.tklastName || '')).toLowerCase().includes(term) ||
          (u.tkEmailId || '').toLowerCase().includes(term))
      : list;
  }

  loadTKUsersGrid(taskId: any, includeToday: any, isReassign: boolean = false) {
    this.loadingTkUsers = true;
    this.tkSearchTerm = '';
    this.filteredTkUsers = [];
    this.taskService.getTKUsersList(taskId, includeToday, isReassign).subscribe(res => {
      this.loadingTkUsers = false;
      this.tkUsers = res && res.data ? res.data : [];
      this.tkUsers.map((obj: any) => {
        obj['mustAcceptList'] = this.timeSlot;
        // .slice(0, obj.totalAvailableTime / 30);
        obj['mustAcceptTime'] = 0;
        obj['totalAvailableTimeStr'] = this.timeConvert(obj['totalAvailableTime']);
        obj['loading'] = false;
      })
      this.applyTkFilter();
    })
  }
  onEnforceMaxChange() {

    if (this.taskForm.controls['rateTypeCode'].value == "Fixed Rate") {
      if (this.catalogueRecord.enforceMax == "Yes") {
        this.taskForm.controls['maxTime'].disable();
        this.clearFormValidation('maxTime')
        this.taskForm.controls['isEnforceMaximum'].disable();
        this.clearFormValidation('isEnforceMaximum')
      } else if (this.taskForm.controls['isEnforceMaximum'].value == "Yes") {
        this.taskForm.controls['maxTime'].setValidators([Validators.required]);
        this.taskForm.controls['maxTime'].updateValueAndValidity();
        this.taskForm.controls['maxTime'].enable();
      } else if (this.taskForm.controls['isEnforceMaximum'].value == "No") {
        this.clearFormValidation('maxTime')
        this.taskForm.controls['maxTime'].enable();
      } else {
        this.clearFormValidation('maxTime')
        this.taskForm.controls['maxTime'].enable();
      }

    } else if (this.taskForm.controls['rateTypeCode'].value == "Hourly") {
      if (this.taskForm.controls['isEnforceMaximum'].value == "Yes") {
        this.taskForm.controls['maxTime'].setValidators([Validators.required]);
        this.taskForm.controls['maxTime'].updateValueAndValidity();
        this.taskForm.controls['maxTime'].enable();
      } else {
        this.clearFormValidation('maxTime')
        this.taskForm.controls['maxTime'].enable();
      }
    } else {
      this.clearFormValidation('maxTime')
    }
  }

  timeConvert(n: any) {
    var num = n;
    var hours = (num / 60);
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    let hStr = rhours ? rhours + " hrs " : "";
    let minsStr = rminutes ? rminutes + " mins" : "";
    return hStr + minsStr;
  }

  includeTodayAssignment(taskId: any, event: any) {
    this.includeToday = event.target.checked;
    this.loadTKUsersGrid(taskId, event.target.checked, this.enableReassignTask);
  }

  assignTaskTKUser() {
    if (!this.TKAssignedUser) {
      this.assignedInvalid = true;
    }
  }

  openAssignNewTask() {
    this.title = "Assign Task to Project"
    this.newTaskDialog = true;
  }

  projectChange(project: any) {
    this.projectAssignedTasks = project.projectTasks;
  }

  closeNewTaskDialog() {
    this.selectedProject = "";
    this.projectAssignedTasks = [];
    this.newTask = "";
    this.accbtnflag = true;
    this.rejbtnflag = true;
    this.loadTasksData(this.lastTableLazyLoadEvent);
  }
  addTemplateTask() {
    this.messageService.clear()
    const payload = {
      projectId: this.selectedProject.id,
      taskIds: [this.newTask.id]
    }
    if (this.assignBtnLoading)
      return;
    this.assignBtnLoading = true;
    try {
      this.taskService.assignTask(payload).subscribe(
        res => {
          this.loadAllProjects()
          this.assignBtnLoading = false;
          if (res?.message) {
            this.viewOnly = true;
            this.scrollToTopDialog();
            this.messageService.add({ severity: 'success', detail: 'Task details have been assigned successfully' });
          } else {
            this.scrollToTopDialog();
            this.messageService.add({ severity: 'error', detail: res.message });
          }
        }, res => {
          this.assignBtnLoading = false;
          this.scrollToTopDialog();
          this.messageService.add({ severity: 'error', detail: res.error.message });
        })
    } catch (error: any) {
      this.assignBtnLoading = false;
      console.log(error)
      this.scrollToTopDialog();
      this.messageService.add({ severity: 'error', detail: error.error.message });
    }
  }
  padZero(number: number) {
    return number.toString().padStart(2, '0');
  }
  deepCopy(obj: any): any {
    let copy: any;

    if (obj instanceof Date) {
      copy = new Date(obj.getTime()); // Create a new Date object with the same timestamp
    } else if (Array.isArray(obj)) {
      copy = obj.map(item => this.deepCopy(item)); // Recursively copy each item in the array
    } else if (typeof obj === 'object' && obj !== null) {
      copy = {};
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          copy[key] = this.deepCopy(obj[key]); // Recursively copy object properties
        }
      }
    } else {
      copy = obj; // Primitive values are directly assigned
    }

    return copy;
  }

  checkDuplicateTR() {
    let hasDuplicate = false;
    const map = new Map<string, number[]>();
    this.timeRecords.forEach((tr: any) => (tr.duplicateTR = false));
    this.timeRecords.forEach((tr: any, index: number) => {
      if (!tr.date || tr.description == null || tr.description === '') {
        return;
      }
      const dateStr = this.filterService.convertDateToFormattedStr(new Date(tr.date));
      const key = dateStr + '||' + tr.description;
      const existing = map.get(key);
      if (existing) {
        existing.forEach((i: number) => (this.timeRecords[i].duplicateTR = true));
        this.timeRecords[index].duplicateTR = true;
        existing.push(index);
        hasDuplicate = true;
      } else {
        map.set(key, [index]);
      }
    });
    this.hasDuplicateTR = hasDuplicate;
    return hasDuplicate;
  }

  isDuplicateTR() {
    var uniqueArray: any = [];
    var map = new Map();
    let tr1 = this.deepCopy(this.timeRecords);
    let flag = true;
    tr1.forEach((tr: any, index: number) => {
      let x = new Date(tr.date);
      // let date = x.toISOString().slice(0, 10);
      let date = this.filterService.convertDateToFormattedStr(x)

      let val = map.get(date)
      console.log(val)
      if (val) {
        val.forEach((description: any) => {
          if (tr1[index].description == description) {
            flag = false;
            this.messageService.clear();
            this.messageService.add({ severity: 'error', detail: 'No Duplicate Descriptions on same day' });
          }
          else {
            map.get(date)?.push(tr1[index].description);
          }
        })

      }
      if (index == 0) {
        map.set(date, [tr1[index].description]);
      }
      if (!map.get(date)) {
        map.set(date, [tr['description']]);
      }
    });
    if (flag) return true
    else return false;
  }

  validateInputs() {
    if (this.timeRecords.length == 0) {
      return false
    }
    let tr = this.deepCopy(this.timeRecords);
    let flag = true;
    for (let i = 0; i < tr.length; i++) {
      this.timeRecords[i].dateValid = tr[i].date ? true : false;
      // this.timeRecords[i].datefutureValid = (new Date(tr[i].date)<=new Date())  ? true : false;
      // if(!this.timeRecords[i].dateValid){
      //   this.timeRecords[i].datefutureValid=true;
      // }
      this.timeRecords[i].descValid = tr[i].description ? true : false;
      this.timeRecords[i].timeValid = tr[i].enteredTime ? true : false;
      flag = flag && this.timeRecords[i].dateValid && this.timeRecords[i].descValid && this.timeRecords[i].timeValid;
      //  && this.timeRecords[i].datefutureValid;  
    }
    return flag;
  }

  saveTR() {
    this.messageService.clear();
    this.cardLoading = true; 
    let duplicateCheck = this.isDuplicateTR()
    if (this.validateInputs() && duplicateCheck) {

      let validtime = this.filterService.convertDateToTime(this.taskForm.getRawValue().maxTime) ? this.filterService.convertDateToTime(this.taskForm.getRawValue().maxTime) : this.filterService.convertDateToTime(this.taskForm.getRawValue().timeEstimate)
      let tr = this.deepCopy(this.timeRecords);
      let timeSum = 0;
      let timeRecordsList: any = [];
      let record: any = {}
      let quantityInvalidFlag = false;
      // let isPendingTrFlag=false;
      // tr.forEach((i: any) => {
      for (let i = 0; i < tr.length; i++) {
        record = tr[i]
        let x = new Date(record.date);
        record.date = this.filterService.convertDateToFormattedStr(x);
        record.enteredTime = this.filterService.convertDateToTime(record.enteredTime)
        delete record.dateValid;
        delete record.descValid;
        delete record.timeValid;
        record.quantity = record.quantityStateList && record.quantityType?.toUpperCase() == 'STATE' ? record.quantityStateList.join(',') : record.quantity;
        if ((this.taskForm.getRawValue().quantityRelated == 'Yes') && (!record.quantity || ((record.quantityType?.toUpperCase() == 'NUMBER') && record.quantity <= 0))) {
          quantityInvalidFlag = true;
          break;
        }
        record.timeRecStatus = record.timeRecStatus ? record.timeRecStatus : null;
        timeRecordsList.push(record);
        timeSum += record.enteredTime;
      }

      // if(isPendingTrFlag){
      //   this.messageService.add({ severity: 'error', detail: 'Task Cannot be Marked as Ready to Complete until all Time Records are Approved' });
      //   return;
      // }

      if (quantityInvalidFlag) {
        this.cardLoading = false;
        this.scrollToTopDialog();
        this.messageService.add({ severity: 'error', detail: 'Please enter valid quantity (cannot be empty).' });
        return;
      }

      let validFlag = (this.taskForm.getRawValue().isEnforceMaximum != 'No' && this.taskForm.getRawValue().openEnded == 'No') ? timeSum <= validtime : true;
      if (validFlag) {
        let payload: any = {};
        payload.taskId = this.taskForm.getRawValue().id;
        payload.billable = this.taskForm.getRawValue().isBillable;

        payload.timeRecords = timeRecordsList;
        // .filter((tr:any)=>!(tr.timeRecStatus?.toUpperCase()=="APPROVED" || tr.timeRecStatus?.toUpperCase()=="REJECTED" || tr.timeRecStatus?.toUpperCase()=="IN REVIEW"));
        payload.taskReadyToComplete = this.taskForm.getRawValue().taskReadyToComplete;
        this.taskService.saveTR(payload).subscribe(
          res => {
            if (res.data.statusCode == 200) {
              this.scrollToTopDialog();
              this.messageService.add({ severity: 'success', detail: 'Time Record added successfully' });
              this.closeDialog();
            }
            else {
              this.scrollToTopDialog();
              this.messageService.add({ severity: 'error', detail: res.message ? res.message : res.data.message ? res.data.message : "Something went wrong while saving Time Record." });
            }
          }, res => {
            this.scrollToTopDialog();
            this.messageService.add({ severity: 'error', detail: res.error.message ? res.error.message : res.error.data.message ? res.error.data.message : "Something went wrong while saving Time Record." });
          }
        )
      }
      else {

        this.scrollToTopDialog();
        this.messageService.add({ severity: 'error', detail: 'The total logged time must not exceed the max time or estimated time.' });
      }

    }
    else {
      if (duplicateCheck) {
        this.scrollToTopDialog();
        this.messageService.add({ severity: 'error', detail: 'Enter valid timerecords' });
      }
    }
  }
  resetForm() {
    this.trForm.reset();
  }


  deleteTR(recordIndex: any) {
    this.timeRecords.splice(recordIndex, 1);
    this.checkDuplicateTR();
  }
  deleteTask(task: any) {
    this.disableDelbtnFlag = true;
    this.loadingData = true;
    this.messageService.clear();
    let payload = {
      "projTaskId": task.id,
      "tkId": task.projTaskAssignmentTkId ? task.projTaskAssignmentTkId : null,
      "rejectTimerecords": this.rejectTimeRecords? this.rejectTimeRecords : false,
      "deleteReason": this.deleteReason? this.deleteReason : ""
    }

    try {
      this.taskService.deleteTask(payload).subscribe(
        (res:any) => {
          this.disableDelbtnFlag = false;
          this.loadingData = false;
          // this.loadAllProjects();
          if (res?.message) {
            if (this.projTasksFilter) this.tasksChanged.emit();
            this.closeDialog();
          } else {
            this.taskForm.enable();
            this.disableTaskOptionalFields()
            this.scrollToTopDialog();
            this.messageService.add({ severity: 'error', detail: res.message });
          }
        }, (res:any) => {
          this.taskForm.enable();
          this.disableTaskOptionalFields()
          this.scrollToTopDialog();
          this.messageService.add({ severity: 'error', detail: res.error.message });
        })
    } catch (error: any) {
      this.taskForm.enable();
      this.disableTaskOptionalFields()
      console.log(error)
      this.scrollToTopDialog();
      this.messageService.add({ severity: 'error', detail: error.error.message });
    }
  }

  saveAssignment(user: any) {
    if (!user.mustAcceptTime || Number(user.mustAcceptTime) < 0) {
      this.messageService.add({ severity: 'error', detail: "Please select time for Must Accept Within." });
      return;
    }
    this.messageService.clear();
    user.loading = true;
    let payload = {
      "tkId": user.tkUserId,
      "projTaskId": this.openTask.id,
      "projId": this.openTask.projectId,
      // "status": "ACCEPT",
      // "timeEstimate": this.filterService.convertDateToTime(this.taskForm.getRawValue().timeEstimate),
      "mustAcceptWithin": Number(user.mustAcceptTime),
      "includeToday": this.includeToday
    }
    this.taskService.assignTaskToTK(payload).subscribe(res => {
      this.messageService.clear();
      this.scrollToTopDialog();
      this.messageService.add({ severity: 'success', detail: user.tkFirstName + " Assigned Successfully." });
      user.loading = false;
      setTimeout(() => {
        this.taskAssignDialog = false;
        this.taskDialog = false;
      }, 100);
    }, res => {
      this.scrollToTopDialog();
      this.messageService.add({ severity: 'error', detail: res.error.message });
    })
  }

  saveReAssignment(user: any) {
    if (!Number(user.mustAcceptTime)) {
      this.scrollToTopDialog();
      this.messageService.add({ severity: 'error', detail: "Please Select time for Must Accept Within!" });
      return;
    }
    user.loading = true;
    let payload: any = {
      "tkId": this.openTask.projTaskAssignmentTkId ? this.openTask.projTaskAssignmentTkId : "",
      "projTaskId": this.openTask.id,
      "projId": this.openTask.projectId,
      "mustAcceptWithin": Number(user.mustAcceptTime),
      "includeToday": this.includeToday,
    }
    payload.reassignReason = this.reassignReason;
    payload.reassignTkId = user.tkUserId;
    payload.taskReassign = true;
    payload.rejectTimeRecords = this.deleteTRAR;
    if (this.deleteTRAR) {
      user.DelLoading = true;
      user.loading = false;
    }
    this.disableReassignbtnFlag = true;
    this.taskService.assignTaskToTK(payload).subscribe(res => {
      this.messageService.clear();
      this.scrollToTopDialog();
      this.messageService.add({ severity: 'success', detail: user.tkFirstName + " Assigned Successfully." });
      user.loading = false;
      setTimeout(() => {
        this.closeDialog()
      }, 100);
    }, res => {
      this.disableReassignbtnFlag = false;
      user.loading = false;
      this.scrollToTopDialog();
      this.messageService.add({ severity: 'error', detail: res.error.message });
    })
  }

  saveTask(saveTaskFlag?: any, isNotReadyFlow: boolean = false) {

    this.messageService.clear();
    if (saveTaskFlag == false) {
      this.closeDialog();
      return;
    }
    if (this.btnLoading)
      return;

    // Validation: Rating should only be provided if task is completed
    const isCompleted = this.taskForm.controls['isCompleted'].value === "Yes";
    const tkRating = this.taskForm.controls['tkRating'].value == "" ? null : this.taskForm.controls['tkRating'].value;
    if (!(this.taskForm.getRawValue().taskTypeCode?.toUpperCase() == "DISBURSEMENTS")) {
      if (isCompleted && (!tkRating || tkRating < 1 || tkRating > 5) && this.taskForm.controls['statusCode']?.value?.toUpperCase() === "APPROVED") {
        this.scrollToTopDialog();
        this.messageService.add({ severity: 'error', detail: 'Please provide a valid rating between 1 and 5.' });
        return;
      }
    }

    if (this.taskForm.controls['countryRelated'].value == "Yes" && this.taskForm.controls['country'].value != "United States" && this.taskForm.controls['country'].value != "Canada") {
      this.taskForm.controls['stateCode'].value = "N/A";
      this.taskForm.controls['stateCode'].patchValue("N/A");
      this.taskForm.get('stateCode').updateValueAndValidity();
    }
    this.submitted = true;
    if (this.taskForm.valid) {
      let projectDueDate = this.taskForm.controls['projectDueDate'].value ? new Date(this.taskForm.controls['projectDueDate'].value) : null;
      let taskDueDate = this.taskForm.controls['taskDueDate'].value ? new Date(this.taskForm.controls['taskDueDate'].value) : null;
      if (!this.isValidDueDate()) {
        this.scrollToTopDialog();
        this.messageService.add({ severity: 'error', detail: "Validation Error while saving details" });
        return;
      }
      if (!this.tkdashboard && taskDueDate && projectDueDate && this.filterService.compareDate(taskDueDate, projectDueDate) > 0 && !saveTaskFlag) {
        this.confirmAction("Are you sure, You want to Exceed Project DueDate ?", 'saveTask');
        this.confirmMsgCategory.push("EXCEED_DUEDATE");
        this.confirmMsgCategory = [...new Set(this.confirmMsgCategory)];
        return;
      }

      if (this.taskForm.controls['isCompleted'].value == "Yes" && this.taskForm.getRawValue().disbursementRelated?.toUpperCase() == 'YES') {
        if (this.taskForm.getRawValue().disbursementTasks?.length == 0) {
          this.scrollToTopDialog();
          this.messageService.add({ severity: 'error', detail: 'Please add at least one Disbursement task to complete Disbursement Related Task.' });
          return;
        }
        const disbursementTasks = this.taskForm.getRawValue().disbursementTasks || [];
        const incompleteTasks = disbursementTasks
          .filter((task: any) => task.isCompleted?.toUpperCase() !== 'YES')
          .map((task: any) => task.id);

        const allCompleted = incompleteTasks.length === 0;
        if (!allCompleted) {
          this.scrollToTopDialog();
          this.messageService.add({
            severity: 'error',
            detail: `All Disbursement tasks must be completed to complete this task. Incomplete Task IDs: ${incompleteTasks.join(', ')}`
          });
          return;
        }
      }
      if (this.taskForm.controls['isCompleted'].value == "Yes" && this.taskForm.getRawValue().taskTypeCode?.toUpperCase() == "DISBURSEMENTS") {
        if (!this.taskForm.getRawValue().datePaid) {
          this.scrollToTopDialog();
          this.messageService.add({ severity: 'error', detail: 'Date Paid is required to complete this disbursement task.' });
          return;
        }
      }

      if (this.taskForm.controls['isCompleted'].value == "Yes" && !saveTaskFlag) {
        const id = this.taskForm.controls['id'].value
        if (id) {
          this.taskService.getExistingTR(id).subscribe(res => {
            if (res.data && res.data.timeRecords && res.data.timeRecords.length == 0 && !(this.taskForm.getRawValue().taskTypeCode?.toUpperCase() == "DISBURSEMENTS")) {
              this.confirmAction("The Task you are completing has no time records.  Are you sure you want to complete this Task?", 'saveTask');
            } else {
              if (this.taskForm.controls['openTasksFlag']?.value?.toUpperCase() == "NO"
                && this.taskForm.controls['isCompleted']?.value?.toUpperCase() == "YES" && !(this.taskForm.getRawValue().taskTypeCode?.toUpperCase() == "DISBURSEMENTS")) {
                if (!saveTaskFlag) {
                  this.confirmAction("By updating this task you are completing all Tasks for this Project, would you like to close the Project Also?", 'saveTask');
                  this.confirmMsgCategory.push("CLOSE_PROJECT");
                  this.confirmMsgCategory = [...new Set(this.confirmMsgCategory)];
                  return;
                }
                else {
                  this.persisTaskData(isNotReadyFlow);
                }
              } else {
                this.persisTaskData(isNotReadyFlow);
              }
            }
          });
        }
      } else {
        this.persisTaskData(isNotReadyFlow);
      }
    } else {
      // Find and print which controls are invalid
      const invalidControls = Object.keys(this.taskForm.controls)
        .filter(key => this.taskForm.controls[key].invalid)
        .map(key => key);
      console.log('Invalid form controls:', invalidControls);
      this.scrollToTopDialog();
      this.messageService.add({
        severity: 'error',
        detail: `Please fill all mandatory fields correctly. `
      });
    }
  }

  scrollToTopDialog() {
    this.cardLoading = false;
    const dialogContent = document.querySelector('.p-dialog .p-dialog-content');
    if (dialogContent) {
      dialogContent.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  persisTaskData(isNotReadyFlow: boolean = false) {
    this.showConfirmAlert = false;

    this.btnLoading = true;

    const id = this.taskForm.controls['id'].value
    if (id)
      delete this.taskForm.value.id
    let payload = this.taskForm.getRawValue()
    
    payload.reviewStatus=payload.reviewStatus=="Select" ? null : payload.reviewStatus;
    payload.tkRating=(payload.tkRating==="" || payload.tkRating==="Select") ? null : payload.tkRating;

    payload.taskDueDate = this.datePipe.transform(payload.taskDueDate, "MM/dd/yyyy");
    payload.datePaid = this.datePipe.transform(payload.datePaid, "MM/dd/yyyy");
    // payload.dateSettled = this.datePipe.transform(payload.dateSettled, "MM/dd/yyyy");
    payload.maxTime = this.filterService.convertDateToTime(payload.maxTime)
    payload.timeEstimate = this.filterService.convertDateToTime(payload.timeEstimate)
    payload.isRequireEstimate = payload.isRequireEstimate == "Yes" ? true : false;
    payload.approved = "Yes";
    payload.editIsCompletedOnly = false;
    delete payload.actualTime
    payload.timeEstimate = payload.timeEstimate || 0;
    delete payload.disbursementTasks;
    // if (payload.statusCode?.toUpperCase() == 'APPROVED' || payload.statusCode?.toUpperCase() == 'COMPLETED' || payload.statusCode?.toUpperCase() == 'READY TO COMPLETE') {
    //   payload.editIsCompletedOnly = true;
    // }

    if (this.confirmMsgCategory.includes("EXCEED_DUEDATE")) {
      payload.projectDueDate = payload.taskDueDate
    } else {
      delete payload.projectDueDate
    }

    if (this.confirmMsgCategory.includes("CLOSE_PROJECT")) {
      if (payload.openTasksFlag && payload.openTasksFlag == "No") {
        payload["finalTaskConfirm"] = "Yes";
      }
    }
    payload['paymentId'] = payload.paymentMethod;
    payload['escrow'] = payload.paymentMethod;
    payload['payeeId'] = payload.payee;

    if (isNotReadyFlow) {
      payload.statusCode = 'Accepted';
    }

    this.taskForm.disable();
    try {
      this.taskService.saveTask(payload, id).subscribe(
        res => {
          this.btnLoading = false;
          if (res?.message) {
            this.viewOnly = true;
            this.scrollToTopDialog();
            this.messageService.add({ severity: 'success', detail: 'Project ' + this.taskForm.controls['taskName'].value + ' details have been saved successfully' });
            if (isNotReadyFlow) {
              this.notReadyToCompletePersist();
            } else {
              setTimeout(() => {
                this.closeDialog();
              }, 500);
            }
            
          } else {
            // this.taskForm.enable();
            // this.disableTaskOptionalFields()
            this.scrollToTopDialog();
            this.messageService.add({ severity: 'error', detail: res?.message || 'Unable to save the task. Please try again.' });
          }
        }, res => {
          this.btnLoading = false;
          // this.taskForm.enable();
          // this.disableTaskOptionalFields()
          this.scrollToTopDialog();
          this.messageService.add({ severity: 'error', detail: res?.error?.message || 'Unable to save the task. Please try again.' });
        })
    } catch (error: any) {
      this.btnLoading = false;
      // this.taskForm.enable();
      // this.disableTaskOptionalFields()
      console.log(error)
      this.scrollToTopDialog();
      this.messageService.add({ severity: 'error', detail: error?.error?.message || 'Unable to save the task. Please try again.' });
    }

  }

  forApproval(task: any) {
    this.title = "For Approval  [Task Id : " + task.id + "]";
    this.forApprovalDialog = true;
    this.FAdisableFlag = false;
    this.rejectedReason = "";
    this.radioStatus = "approve";
    task.isBillable = this.filterService.getflagBoolean(task.isBillable);
    task.isCompleted = this.filterService.getflagBoolean(task.isCompleted);
    task.includeToday = this.filterService.getflagBoolean(task.includeToday);
    task.timeEstimate = this.filterService.convertTimeToDate(task.timeEstimate);
    task.timeRecordsLoggedTime = this.filterService.convertTimeToDate(task.timeRecordsLoggedTime);
    task.maxTime = task.maxTime ? this.filterService.convertTimeToDate(task.maxTime) : this.filterService.convertTimeToDate(0);
    this.taskForm.patchValue(task);
    this.taskForm.disable();
    if (task.projectIsBillable && task.projectIsBillable == 'No') {
      this.clearFormValidation('isBillable');
      this.taskForm.controls['isBillable'].disable();
    } else {
      this.taskForm.controls['isBillable'].enable();
    }
    this.taskForm.controls.tkRating.enable();
    this.loadTRData(task);
  }

  approveTask(taskForm: any, persist_flag?: boolean) {
    this.messageService.clear();
    if ((this.taskForm.getRawValue().taskTypeCode?.toUpperCase() != "DISBURSEMENTS")
      && (this.taskForm.controls.tkRating.value < 1 || this.taskForm.controls.tkRating.value > 5)) {
      this.scrollToTopDialog();
      this.messageService.add({ severity: 'error', detail: 'Please provide a valid rating between 1 and 5.' });
      return;
    }
    // if(this.taskForm.controls['openTasksFlag']?.value=="No"
    //    && !["APPROVED"].includes(this.taskForm.controls['statusCode'].value.toUpperCase()) && !persist_flag){
    //   this.confirmAction("By updating this task you are completing all Tasks for this Project, would you like to close the Project Also?", 'approveTask');
    //   this.confirmMsgCategory.push("CLOSE_PROJECT");
    //   this.confirmMsgCategory = [...new Set(this.confirmMsgCategory)];
    //   return;
    // }
    this.faloading = true;
    var payload: any = [
      {
        "projTaskId": taskForm.controls.id.value,
        "billable": taskForm.getRawValue().isBillable,
        "status": "Approved",
        "tkRating": taskForm.getRawValue().tkRating,
        // "finalTaskConfirm": this.confirmMsgCategory.includes("CLOSE_PROJECT") ? "Yes" : "No"
      }
    ];
    this.taskService.approveOrRejectTask(payload).subscribe(res => {
      if (res.data[0].message == "SUCCESS") {
        this.faloading = false;
        this.FAdisableFlag = true;
        this.taskForm.controls.isBillable.disable();
        this.taskForm.controls.tkRating.disable();
        this.scrollToTopDialog();
        this.messageService.add({ severity: 'success', detail: 'Successfully Approved project task status.' });
      } else if (res?.data[0].statusCode == 500) {
        this.faloading = false;
        this.scrollToTopDialog();
        this.messageService.add({ severity: 'error', detail: res.data[0].message });
      }
    }, res => {
      this.faloading = false;
      this.scrollToTopDialog();
      this.messageService.add({ severity: 'error', detail: res.error.message });
    })
  }
  rejectTask(taskForm: any) {
    this.faloading = true;
    var payload: any = [
      {
        "projTaskId": taskForm.controls.id.value,
        "status": "Rejected",
        "rejectReason": this.rejectedReason,
        "tkRating": taskForm.controls.tkRating.value
      }
    ];
    this.taskService.approveOrRejectTask(payload).subscribe(res => {
      if (res.data[0].message == "SUCCESS") {
        this.faloading = false;
        this.FAdisableFlag = true;
        this.taskForm.controls.isBillable.disable();
        this.taskForm.controls.tkRating.disable();
        this.scrollToTopDialog();
        this.messageService.add({ severity: 'success', detail: 'Successfully Rejected project task status.' });
      }
    }, res => {
      this.faloading = false;
      this.scrollToTopDialog();
      this.messageService.add({ severity: 'error', detail: res.error.message });
    })
  }
  loadTRData(task: any) {
    this.loadingTRData = true;
    this.taskService.getExistingTR(task.id).subscribe(res => {
      this.loadingTRData = false;
      this.timeRecords = res.data.timeRecords;
      if (this.timeRecords.length > 0) {
        this.timeRecords.map((obj: any) => {
          obj["date"] = new Date(obj["date"])
          obj["enteredTime"] = this.filterService.convertTimeToDate(obj["enteredTime"]);
          obj['quantityType'] = task.quantityType;
          if (obj['quantityType'] != "Number") {
            obj['quantityStateList'] = task.quantity?.split(",");
          } else {
            obj['quantity'] = task.quantity
          }
        })
      }

    })
  }
  addTimeRecord(taskForm: any) {
    let disableQuantity = false;
    if (this.taskForm.controls['isPreInvoiced'].value === 'Yes' && this.taskForm.controls['isPrePaid'].value === 'Yes' && this.taskForm.controls['quantityRelated'].value == 'Yes' && this.taskForm.controls['quantityType'].value) {
      disableQuantity = true;
      this.messageService.clear();
      this.scrollToTopDialog();
      this.messageService.add({ severity: 'info', detail: 'This is a prepaid project and you cannot modify the quantity.  If you need to increase the quantity, please contact the project administrator to add and assign a new Task to increase quantity.' });
    }

    if (taskForm.descriptionTypeCode == 'Auto' || !taskForm.descriptionTypeCode) {
      this.timeRecords.push({
        description: taskForm.description ? taskForm.description : "",
        tkComment: taskForm.tkComment ? taskForm.tkComment : "",
        dateValid: true,
        datefutureValid: true,
        descValid: true,
        timeValid: true,
        disableDel: false,
        disableInp: false,
        disableQuantity: disableQuantity ? disableQuantity : false,
        quantityType: taskForm.quantityType,
        quantityStateList: taskForm.quantityState ? taskForm.quantityState.map((obj: any) => obj.stateDesc) : [],
        quantity: taskForm.quantityNumber,
        timeRecStatus: taskForm.timeRecStatus ? taskForm.timeRecStatus : null
      })
    }
    else {
      this.timeRecords.push({
        tkComment: "",
        description: "",
        dateValid: true,
        datefutureValid: true,
        descValid: true,
        timeValid: true,
        disableDel: false,
        disableInp: false,
        disableQuantity: disableQuantity ? disableQuantity : false,
        quantityType: taskForm.quantityType,
        quantityStateList: taskForm.quantityState ? taskForm.quantityState.map((obj: any) => obj.stateDesc) : [],
        quantity: taskForm.quantityNumber,
        timeRecStatus: null
      })
    }
    this.checkDuplicateTR();
  }

  openDeleteTaskPopup(task: any) {
    this.title = "Delete Task [Task Id : " + task.id + "]";
    task.timeRecordsLoggedTime = task.timeRecordsLoggedTime ?? -1;
    this.taskForm.patchValue(task);
    this.deleteReason = "";
    this.disableDelbtnFlag = true;

    const status = task.statusCode?.toUpperCase();
    const loggedTime = task.timeRecordsLoggedTime;

    if (task.disbursementRelated?.toUpperCase() == 'YES') {
      this.deleteConfirmationDialog = true;
      this.deleteConfirmationDialogText = `You are deleting a Disbursement Related Task with a corresponding Disbursement Task. Deleting this Task will also delete the Disbursement Task. Are you sure you want to delete this Task?`;
      return;
    }

    if (status === 'OPEN') {
      this.deleteConfirmationDialog = true;
      this.deleteConfirmationDialogText = "Are you sure you want to delete this task?";
      return;
    }

    if (
      status === 'ASSIGNED' ||
      (status === 'ACCEPTED' && loggedTime < 0) 
    ) {
      this.openAssignTask(task, true);
      this.enableDeleteTask = true;
      return;
    }

    this.openAddTR(task, true);
    
  }
  handleTabChange(table: Table, event: any) {
    this.loading = true;
    this.tasks = [];
    if (event.index == 0) {
      this.tkdashboard = false;
    } else {
      this.tkdashboard = true;
    }
    // table.clear();
    this.loadTasksData(this.lastTableLazyLoadEvent);
  }
  isCompletedOnchange(value: any) {
    const status = this.taskForm.get('statusCode')?.value?.toUpperCase();
    const isAdminOrLpc = this.userrole?.includes('ADMIN') || this.userrole?.includes('LPC');
    const tkRatingControl = this.taskForm.get('tkRating');
    const dueDateControl = this.taskForm.get('taskDueDate');

    // if (
    //   ['ACCEPTED', 'FOR APPROVAL', 'READY TO COMPLETE'].includes(status) &&
    //   isAdminOrLpc &&
    //   !this.tkdashboard
    // ) {
    if (value?.toUpperCase() === 'YES') {
      this.tkRatingMand = true;
      dueDateControl?.disable();
      dueDateControl?.setValidators([]);
      dueDateControl?.updateValueAndValidity();

      tkRatingControl?.enable();
      tkRatingControl?.setValidators([Validators.required]);
      tkRatingControl?.updateValueAndValidity();

      this.clearFormValidation('taskDueDate');
    } else {
      this.tkRatingMand = false;
      dueDateControl?.enable();
      dueDateControl?.setValidators([Validators.required]);
      dueDateControl?.updateValueAndValidity();

      tkRatingControl?.disable();
      tkRatingControl?.setValidators([]);
      tkRatingControl?.updateValueAndValidity();

      this.clearFormValidation('tkRating');
    }
    if (this.taskForm.getRawValue().taskTypeCode?.toUpperCase() == "DISBURSEMENTS") {
      this.clearFormValidation('tkRating');
      tkRatingControl.setValue(0);
    }
  }
  clearFormValidation(value: any) {
    this.taskForm.get(value).clearValidators()
    this.taskForm.get(value).setErrors(null);
    this.taskForm.get(value).updateValueAndValidity();
  }

  clicked(task: any) {
    this.selectedTask = task;
    // if(task.disableEditTask){
    //   this.viewTask(task, true);
    // }else{
    //   this.editTask(task, true);
    // }

    this.viewTask(task, true);

  }

  editTaskInDetailedView() {
    this.viewOnly = false;
    this.editTask(this.selectedTask, true);
  }

  backToTasksGrid() {
    this.viewTaskName = "";
    this.selectedTask = null;
    this.showProjectsView = false;
    this.loadTasksData(this.lastTableLazyLoadEvent);
  }


  get timeEstimate() {
    return this.taskForm.get('timeEstimate');
  }
  get actualTime() {
    return this.taskForm.get('actualTime');
  }
  get stateCode() {
    return this.taskForm.get('stateCode');
  }
  get country() {
    return this.taskForm.get('country');
  }
  get consolidatedTimeRecords() {
    return this.taskForm.get('consolidatedTimeRecords');
  }
  get statusCode() {
    return this.taskForm.get('statusCode');
  }
  get quantityState() {
    return this.taskForm.get('quantityState');
  }
  get quantityNumber() {
    return this.taskForm.get('quantityNumber');
  }
  get approver() {
    return this.taskForm.get('approver');
  }
  get openEnded() {
    return this.taskForm.get('openEnded');
  }
  get approved() {
    return this.taskForm.get('approved');
  }
  get holdTimeUntilComp() {
    return this.taskForm.get('holdTimeUntilComp');
  }
  get quantityRelated() {
    return this.taskForm.get('quantityRelated');
  }
  get quantityType() {
    return this.taskForm.get('quantityType');
  }
  get isApprovalRequired() {
    return this.taskForm.get('isApprovalRequired');
  }
  get taskDueDate() {
    return this.taskForm.get('taskDueDate');
  }
  get isRequireEstimate() {
    return this.taskForm.get('isRequireEstimate');
  }
  get isBillable() {
    return this.taskForm.get('isBillable');
  }
  get isCompleted() {
    return this.taskForm.get('isCompleted');
  }
  get practiceAreaCode() {
    return this.taskForm.get('practiceAreaCode');
  }
  get tkRating() {
    return this.taskForm.get('tkRating');
  }
  get openTasksFlag() {
    return this.taskForm.get('openTasksFlag');
  }
  get dbStatusCode() {
    return this.taskForm.get('dbStatusCode');
  }
  get taskTypeCode() {
    return this.taskForm.get('taskTypeCode');
  }

  get disbursementTasks() {
    return this.taskForm.get('disbursementTasks');
  }
  get paymentReferenceNumber() {
    return this.taskForm.get('paymentReferenceNumber');
  }
  get paymentMethod() {
    return this.taskForm.get('paymentMethod');
  }
  get payeeInvoiceNumber() {
    return this.taskForm.get('payeeInvoiceNumber');
  }
  get payee() {
    return this.taskForm.get('payee');
  }
  get transactionType() {
    return this.taskForm.get('transactionType');
  }
  get disbursementAmount() {
    return this.taskForm.get('disbursementAmount');
  }
  get receipt() {
    return this.taskForm.get('receipt');
  }
  get datePaid() {
    return this.taskForm.get('datePaid');
  }
  get nonBillableReason() {
    return this.taskForm.get('nonBillableReason');
  }
  get entityId() {
    return this.taskForm.get('entityId');
  }
  // get dateSettled() {
  //   return this.taskForm.get('dateSettled');
  // }


  onDateFilterChange(field: any) {
    this.filterDates[field] = null
  }

  clearDatesFilter(field: any) {
    console.log('Clear date filter', field);
    this.filterDates[field] = null;
    this.dateFilters = this.dateFilters.filter((filter: any) => filter.field !== field);
    this.loadTasksData(this.lastTableLazyLoadEvent);
  }
  applyDatesFilter(field: any) {
    console.log("apply", this.filterDates[field], this.filterDatesMatchModes[field]);
    let dates = this.filterDates[field]
    const index = this.dateFilters.findIndex((filter: any) => filter.field === field);
    if (index > -1) {
      this.dateFilters.splice(index, 1);
    }
    if (this.filterDatesMatchModes[field] == 'betweenDate') {
      this.dateFilters.push({
        field: field, operator: "betweenDate", value: this.filterService.convertDateToFormattedPayloadStr(dates[0]),
        valueTo: this.filterService.convertDateToFormattedPayloadStr(dates[1])
      });
    } else {
      this.dateFilters.push({ field: field, operator: this.filterDatesMatchModes[field], value: this.filterService.convertDateToFormattedPayloadStr(dates) });
    }
    this.loadTasksData(this.lastTableLazyLoadEvent);
  }

  /**
   * Apply widget filters to the table UI components
   */
  applyWidgetFiltersToUI(): void {
    if (!this.widgetFilters || this.widgetFilters.length === 0) {
      return;
    }

    try {
      // Clear any existing table filters for widget filter fields to prevent empty filter panels
      // if (this.table && this.table.filters) {
      //   this.table.filters = this.defaultFilters
      // }

      // this.selectedFilterOption="My Tasks";

      this.widgetFilters.forEach((filter: any) => {
        // Handle date filters
        if (filter.field === 'taskDueDate') {
          // Remove any existing taskDueDate filter from dateFilters to prevent duplication
          const index = this.dateFilters.findIndex((f: any) => f.field === 'taskDueDate');
          if (index > -1) {
            this.dateFilters.splice(index, 1);
          }

          // Handle different date operators
          if (filter.operator === 'betweenDate' && filter.value && filter.valueTo) {
            // For betweenDate, set both value and valueTo as an array
            const startDate = new Date(filter.value);
            const endDate = new Date(filter.valueTo);

            // Set the component properties that are bound to the UI
            this.filterDatesMatchModes.taskDueDate = 'betweenDate';
            this.filterDates.taskDueDate = [startDate, endDate];

            // Note: DO NOT set this.table.filters for widget filters
            // Widget filters are handled separately via this.widgetFilters array
          }
          else if (filter.operator === 'ltDate' && filter.value) {
            // For ltDate (before)
            const date = new Date(filter.value);

            // Set the component properties that are bound to the UI
            this.filterDatesMatchModes.taskDueDate = 'ltDate';
            this.filterDates.taskDueDate = date;

            // Note: DO NOT set this.table.filters for widget filters
            // Widget filters are handled separately via this.widgetFilters array
          }
          else if (filter.operator === 'gtDate' && filter.value) {
            // For gtDate (after)
            const date = new Date(filter.value);

            // Set the component properties that are bound to the UI
            this.filterDatesMatchModes.taskDueDate = 'gtDate';
            this.filterDates.taskDueDate = date;

            // Note: DO NOT set this.table.filters for widget filters
            // Widget filters are handled separately via this.widgetFilters array
          }
          else if (filter.operator === 'dateIs' && filter.value) {
            // For dateIs (exact date)
            const date = new Date(filter.value);

            // Set the component properties that are bound to the UI
            this.filterDatesMatchModes.taskDueDate = 'dateIs';
            this.filterDates.taskDueDate = date;

            // Note: DO NOT set this.table.filters for widget filters
            // Widget filters are handled separately via this.widgetFilters array
          }
          else if (filter.operator === 'equals' && filter.value === null) {
            // For null/no due date - this doesn't have a UI representation in the date filter
          }
        }
        // Handle non-date filters (isCompleted, isDeleted, isRejected, statusCode, etc.)
        // Note: DO NOT set these in this.table.filters as they don't have UI components
        // They are backend-only filters that are sent via this.widgetFilters array
      });

      // Trigger change detection to update the UI (only if component is not destroyed)
      if (!this.isDestroyed) {
        this.cdr.detectChanges();
      }
    } catch (error) {
      console.error('Error applying widget filters to UI:', error);
    }
  }

  clearAllFilters(table: Table) {
    this.router.navigateByUrl("/task-grid");
    this.notifyTaskIdPayload=null;
    this.searchTerm = '';
    this.selectedFilterOption = 'All Tasks';
    this.dateFilters = [];
    this.widgetFilters = []; // Clear widget filters as well
    Object.keys(this.filterDatesMatchModes).map((field: any) => this.filterDatesMatchModes[field] = '')
    Object.keys(this.filterDates).map((field: any) => this.filterDates[field] = null)
    table.clear();
  }

  onDateSelect(field: any, event: any) {
    if (this.filterDatesMatchModes[field] == 'betweenDate' && this.filterDates[field].length == 2 && this.filterDates[field][0] && this.filterDates[field][1]) {
      const calendarElement = document.querySelector('.p-calendar');
      if (calendarElement) {
        const overlay = document.querySelector('.p-datepicker');
        if (overlay)
          (overlay as HTMLElement).style.display = 'none';
      }
    }
  }

  // Comments methods
  openComments(task: any) {
    this.selectedTaskForComments = task;
    this.commentsDialog = true;
  }

  handleNotificationNavigation() {
    this.notificationNavService.checkAndOpenCommentsFromNotification(
      this.tasks,
      this.searchTerm,
      (task: any) => this.handleCommentOpenFromNotification(task),
      (taskId: number) => this.handleTaskSearch(taskId),
      () => this.handleSearchClear(),
      this.cdr
    );
  }

  private handleCommentOpenFromNotification(task: any) {
    // Close any existing modal first
    if (this.commentsDialog) {
      console.log('Closing existing comments dialog');
      this.closeCommentsDialog();
    }

    // Open the comments modal
    this.openComments(task);
  }

  private handleTaskSearch(taskId: number) {
    this.notificationNavService.searchForTaskById(
      taskId,
      (term: string) => this.searchTerm = term,
      (event: any) => this.loadTasksData(event),
      this.lastTableLazyLoadEvent,
      this.cdr
    );
  }

  private handleSearchClear() {
    this.searchTerm = '';
    this.cdr.detectChanges();
    this.loadTasksData(this.lastTableLazyLoadEvent);
  }

  closeCommentsDialog() {
    this.commentsDialog = false;
    this.selectedTaskForComments = null;
  }

  getFieldInfo(fieldKey: string): FieldInfo | undefined {
    return this.fieldInfoService.getAllFields().find((f: FieldInfo) => f.gridName === 'Project Task' && f.fieldKeyName === fieldKey);
  }

  /**
   * Builds the payload with filters, sort, category, and searchTerm
   * Reusable for both data loading and export operations
   */
  async buildTaskPayload(event: LazyLoadEvent): Promise<any> {
    await this.getLoginUserMail();
    let payload = this.filterService.generateEventPayload(event);

    // Add project filter if exists
    if (this.projTasksFilter) {
      payload.filters.push({
        "field": "projectId",
        "operator": "equals",
        "value": this.projTasksFilter
      });
    }

    // Add date filters
    if (this.dateFilters) {
      payload.filters = payload.filters.concat(this.dateFilters);
    }

    // Add widget filters if available
    // Widget filters should always be included as they represent the user's intent from the widget
    if (this.widgetFilters && this.widgetFilters.length > 0) {
      // Remove any existing filters in payload that have the same field as widget filters
      // This ensures widget filters take precedence
      const widgetFilterFields = this.widgetFilters.map((f: any) => f.field);
      payload.filters = payload.filters.filter((f: any) => !widgetFilterFields.includes(f.field));
      
      // Now add all widget filters
      payload.filters = payload.filters.concat(this.widgetFilters);
      
      // Add fromWidgetFilters flag when navigating from widget
      payload.fromWidgetFilters = true;
    }

    // Add category-specific filters
    if (this.selectedFilterOption == 'My Tasks') {
    
      payload["category"] = "My Tasks";
      payload.filters.push(
        {
          "field": "createdBy",
          "operator": "equals",
          "value": this.auth.jwtData.email,
          "logicGrp": "OR"
        }
      );
      payload.filters.push(
        {
          "field": "projTaskAssignmentUsername",
          "operator": "equals",
          "value": this.auth.jwtData.email,
          "logicGrp": "OR"
        }
      );
      payload.filters.push(
        {
          "field": "approver",
          "operator": "equals",
          "value": this.loggedInId,
          "logicGrp": "OR"
        }
      );
    } else if (this.selectedFilterOption == 'My Approval Tasks') {
      payload["category"] = "All Tasks";
      payload.filters.push(
        {
          "field": "approver",
          "operator": "equals",
          "value": this.loggedInId,
          "logicGrp": "OR"
        }
      );
      payload.filters.push(
        {
          "field": "statusCode",
          "operator": "in",
          "values": [
            "For Approval",
            "Ready To Complete",
          ]
        }
      );
    } else if ((this.selectedFilterOption == 'Past Dues' || this.selectedFilterOption == 'Billing Closeouts')
        && this.isScopeAllowed(this.selectedFilterOption)) {
      payload["category"] = "All Tasks";
      payload.filters.push({ "field": "isCompleted", "operator": "equals", "value": "No" });
      payload.filters.push({
        "field": "taskDueDate",
        "operator": "ltDate",
        "value": this.datePipe.transform(new Date(), 'yyyy-MM-dd')
      });
      if (this.selectedFilterOption == 'Billing Closeouts') {
        payload.filters.push({ "field": "isBillable", "operator": "equals", "value": "Yes" });
        payload.filters.push({ "field": "rateTypeCode", "operator": "equals", "value": "Fixed Rate" });
      }
      if (!payload.sort || payload.sort.length === 0) {
        payload.sort = [{ "field": "taskDueDate", "order": "ASC" }];
      }
    } else {
      payload["category"] = "All Tasks";
    }

    // Add search term
    payload["searchTerm"] = this.searchTerm;

    return payload;
  }

  async exportTasks() {
    // Reuse the same payload builder to ensure consistency
    let payload = await this.buildTaskPayload(this.lastTableLazyLoadEvent || {} as LazyLoadEvent);

    this.btnLoading = true;
    this.taskService.exportTasks(payload,this.activeTab).subscribe(
      (res: any) => {
        this.btnLoading = false;
        const responseBody = res.body;
        const contentType = res.headers.get('Content-Type');

        // Check for CSV, Excel, or octet-stream content types
        if (responseBody && responseBody instanceof ArrayBuffer && responseBody.byteLength > 0) {
          const contentDisposition: any = res.headers.get('Content-Disposition');
          let filename = 'tasks_export.xlsx'; // Default to Excel

          // Extract filename from Content-Disposition header
          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (filenameMatch && filenameMatch[1]) {
              filename = filenameMatch[1].replace(/['"]/g, '');
            }
          } else if (contentType) {
            // If no Content-Disposition, determine extension from Content-Type
            if (contentType.includes('spreadsheetml.sheet') || contentType.includes('vnd.openxmlformats')) {
              filename = 'tasks_export.xlsx';
            } else if (contentType.includes('vnd.ms-excel')) {
              filename = 'tasks_export.xls';
            } else if (contentType.includes('text/csv')) {
              filename = 'tasks_export.csv';
            }
          }

          this.downloadFile(responseBody, filename);
          this.messageService.add({ severity: 'success', detail: 'Tasks exported successfully!' });
        } else {
          Swal.fire("Nothing to Export.");
        }
      },
      (error) => {
        this.btnLoading = false;
        console.error('Export error:', error);
        this.messageService.add({ severity: 'error', detail: 'Failed to export tasks' });
      }
    );
  }

  downloadFile(data: ArrayBuffer, filename: string) {
    // Add timestamp to filename if not already present
    const now = new Date();
    const timestamp = now.getFullYear() + '-' +
      String(now.getMonth() + 1).padStart(2, '0') + '-' +
      String(now.getDate()).padStart(2, '0') + '_' +
      String(now.getHours()).padStart(2, '0') + '-' +
      String(now.getMinutes()).padStart(2, '0') + '-' +
      String(now.getSeconds()).padStart(2, '0');

    const filenameParts = filename.split('.');
    const extension = filenameParts.pop();
    const baseName = filenameParts.join('.');

    // Check if filename already has a timestamp pattern
    if (!baseName.match(/\d{4}-\d{2}-\d{2}_\d{2}-\d{2}-\d{2}/)) {
      filename = `${baseName}_${timestamp}.${extension}`;
    }

    // Determine MIME type based on file extension
    let mimeType = 'application/octet-stream';
    if (extension === 'xlsx') {
      mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    } else if (extension === 'xls') {
      mimeType = 'application/vnd.ms-excel';
    } else if (extension === 'csv') {
      mimeType = 'text/csv';
    }

    const blob = new Blob([data], { type: mimeType });
    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = filename;
    downloadLink.click();
    URL.revokeObjectURL(downloadLink.href);
  }

  restoreTaskState(saved: any) {
    const event = saved.event;
    const cf = saved.customFilters;
    const widgetState = history.state;

    if (widgetState && widgetState.filters && (widgetState.fromWidget || widgetState.fromEntity)) {
      return; // Skip saving state if navigated from widget or entity with filters
    }

    // Restore custom filters
    this.selectedFilterOption = this.isScopeAllowed(cf.selectedFilterOption) ? cf.selectedFilterOption : 'All Tasks';
    this.dateFilters = cf.dateFilters;
    // // Only restore widgetFilters if we don't have fresh ones from navigation
    // // This prevents overwriting filters from widget navigation with stale saved state
    // if (!this.widgetFilters || this.widgetFilters.length === 0) {
    //   this.widgetFilters = cf.widgetFilters;
    // }
    this.searchTerm = cf.searchTerm;

    setTimeout(() => {
      if (this.table) {

        const filtersAreValid = event.filters && Object.keys(event.filters).length > 0;

        // 2. Assign filters: Use saved filters if valid, otherwise use the captured default filters.
        if (filtersAreValid) {
          this.table.filters = event.filters;
        } else if (Object.keys(this.defaultFilters).length > 0) {
          // 🔥 Use the default structure as a fallback to prevent empty filter popups
          this.table.filters = this.defaultFilters;
        }

        // Restore sorting
        this.table.sortField = event.sortField ?? '';
        this.table.sortOrder = event.sortOrder ?? 0;

        // 🔥 force PrimeNG to show sorting icons
        this.table.sortSingle();

        // Restore paginator
        this.table.first = event.first ?? 0;
        this.table.rows = event.rows ?? 10;

        this.table.onLazyLoad.emit(event);
        
      }
    }, 50);
    this.taskInitialLoadDone = true;
  }
  saveState(screen: string, userId: string, event: LazyLoadEvent, customFilters: any) {
    if(this.projTasksFilter)
      return;
    if(this.notifyTaskIdPayload)
      return; // Skip saving state when navigating from notification to prevent overwriting with stale state
    const widgetState = history.state;

    if (widgetState && widgetState.filters && (widgetState.fromWidget || widgetState.fromEntity)) {
      return; // Skip saving state if navigated from widget or entity with filters
    }
    const state: SavedTableState = {
      event: {
        first: event.first,
        rows: event.rows,
        sortField: event.sortField,
        sortOrder: event.sortOrder,
        filters: event.filters
      },
      customFilters: { ...customFilters }
    };

    this.tableStateService.saveState(screen, userId, state);
  }

  ngAfterViewInit() {
    // Capture the table's initial, un-filtered state structure
    // This needs a slight delay to ensure the table component is ready.
    setTimeout(() => {
      if (this.table && this.table.filters) {
        // Deep clone the initial filters to use as a fallback
        this.defaultFilters = JSON.parse(JSON.stringify(this.table.filters));
      }
    });
  }

  clearWidgetsFilter(){
    this.widgetFilters = [];
    this.filterSource = '';
    history.state.fromWidget = false;
    history.state.fromEntity = false;
    history.state.filters = null;
    const saved = this.projTasksFilter ? null : this.tableStateService.getState(this.taskScreenName+this.activeTab, this.taskUserId);

    if (saved) {
      this.restoreTaskState(saved);
    } 
  }
  getSelectedStateLabels(){
    const selectedStates = this.taskForm.get('quantityState')?.value;
    return selectedStates ? this.stateCodeMapList.filter((state: any) => selectedStates.includes(state.value)).map((state: any) => state.label).join(', ') : '';
  }

  getSelectedStateLabelsList(){
    const selectedStates = this.taskForm.get('quantityState')?.value;
    return selectedStates ? this.stateCodeMapList.filter((state: any) => selectedStates.includes(state.value)).map((state: any) => state.label) : [];
  }

  timeSectionSummary(): string {
    const v = this.taskForm.getRawValue();
    const parts: string[] = [];
    if (v.actualTime) parts.push(v.actualTime + ' actual');
    if (v.progress) parts.push(v.progress + ' of estimate');
    if (v.isEnforceMaximum === 'Yes') parts.push('max enforced');
    if (v.holdTimeUntilComp === 'Yes') parts.push('time held');
    return parts.join(' · ');
  }

  billingSectionSummary(): string {
    const v = this.taskForm.getRawValue();
    const parts: string[] = [];
    if (v.isBillable === 'Yes') parts.push('Billable');
    else if (v.isBillable === 'No') parts.push(v.nonBillableReason ? 'Non-billable — ' + v.nonBillableReason : 'Non-billable');
    if (v.isApprovalRequired === 'Yes') parts.push('approval required');
    if (v.isPreInvoiced === 'Yes') parts.push('pre-invoiced');
    if (v.isPrePaid === 'Yes') parts.push('pre-paid');
    return parts.join(' · ');
  }

  classificationSectionSummary(): string {
    const v = this.taskForm.getRawValue();
    const parts: string[] = [];
    const states = Array.isArray(v.quantityState) ? v.quantityState.length : 0;
    if (states) parts.push(states + (states === 1 ? ' quantity state' : ' quantity states'));
    else if (v.quantityNumber) parts.push('quantity ' + v.quantityNumber);
    if (v.practiceAreaCode) parts.push(v.practiceAreaCode);
    if (v.stateCode) parts.push(v.stateCode);
    else if (v.country) parts.push(v.country);
    if (v.tkRating) parts.push('TK rating ' + v.tkRating);
    return parts.join(' · ');
  }

  taskFieldLabels: { [key: string]: string } = {
    taskName: 'Task Name', projectName: 'Project Name', taskTypeCode: 'Task Type',
    disbursementRelated: 'Disbursement Related', actualTime: 'Actual Time', statusCode: 'Task Status',
    isCompleted: 'Task Completed', rateTypeCode: 'Rate Type Code', isEnforceMaximum: 'Enforced Max Time',
    catEnforceMax: 'Catalogue Enforced Max', countryRelated: 'Country Related',
    isStateRelated: 'State Related', stateCode: 'State', country: 'Country',
    timeEstimate: 'Estimated Time', maxTime: 'Max Time', isBillable: 'Billable',
    consolidatedTimeRecords: 'Consolidated Time Records', isRequireEstimate: 'Required Estimate',
    isApprovalRequired: 'Approval Required', taskDueDate: 'Due Date', openEnded: 'Open Ended',
    quantityType: 'Quantity Type', quantityState: 'Quantity', quantityNumber: 'Quantity',
    dueDaySlot: 'Due Day Slot', tkRating: 'TK Rating', holdTimeUntilComp: 'Hold Time Until Completed',
    approver: 'Task Approver', practiceAreaCode: 'Practice Area', progress: 'Task Progress',
    reviewStatus: 'Review Status', description: 'Description', nonBillableReason: 'Non Billable Reason',
    isPreInvoiced: 'Pre-Invoiced', isPrePaid: 'Pre-Paid', entityId: 'Entity', notes: 'Task Notes',
    driveLink: 'One Drive Link', stateDesc: 'State', transactionType: 'Transaction Type',
    paymentMethod: 'Payment Method', escrowAccountId: 'Escrow Client', payee: 'Payee',
    payeeInvoiceNumber: 'Payee – Invoice Number', paymentReferenceNumber: 'Payment Reference Number',
    datePaid: 'Date Paid', receipt: 'Receipt', disbursementAmount: 'Disbursement Amount',
    newDisbursementTaskIds: 'Disbursement Tasks'
  };

  getChangedFieldLabels(): string[] {
    const controls = this.taskForm.controls;
    const labels: string[] = [];
    Object.keys(controls).forEach((name: string) => {
      if (controls[name].dirty && this.taskFieldLabels[name]) {
        const label = this.taskFieldLabels[name];
        if (labels.indexOf(label) < 0) labels.push(label);
      }
    });
    return labels;
  }

  requestCloseTaskDialog() {
    if (this.viewOnly || !this.taskForm.dirty) {
      this.closeDialog();
      return;
    }
    const changed = this.getChangedFieldLabels();
    const detail = changed.length ? changed.join(', ') : 'this task';
    this.confirmAction('You have unsaved changes to ' + detail + '. Discard them and close?', 'discardTaskEdits');
  }

  wsEstimateUsedPct(): number {
    const raw = this.taskForm.getRawValue().progress;
    if (!raw) return 0;
    const n = parseFloat(String(raw).replace('%', ''));
    return isNaN(n) ? 0 : Math.max(0, Math.min(100, n));
  }

  wsEstimateText(): string {
    const raw = this.taskForm.getRawValue().timeEstimate;
    if (!raw) return '';
    if (raw instanceof Date && !isNaN(raw.getTime())) {
      return `${String(raw.getHours()).padStart(2, '0')}:${String(raw.getMinutes()).padStart(2, '0')}`;
    }
    const value = String(raw).trim();
    const time = value.match(/^(\d{1,2}):(\d{2})/);
    return time ? `${time[1].padStart(2, '0')}:${time[2]}` : value;
  }

  assignmentDueDateText(): string {
    const value = this.taskForm.get('taskDueDate')?.value;
    if (!value) return 'Not set';
    if (typeof value === 'string') return value;
    return this.datePipe.transform(value, 'MM/dd/yyyy') || 'Not set';
  }

  wsOverdueText(): string {
    const v = this.taskForm.getRawValue();
    if (!v.taskDueDate || String(v.statusCode).toLowerCase() === 'completed') return '';
    const due = new Date(v.taskDueDate);
    if (isNaN(due.getTime())) return '';
    const today = new Date();
    due.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    const days = Math.round((today.getTime() - due.getTime()) / 86400000);
    if (days === 0) return 'Due today';
    if (days > 0) return days + (days === 1 ? ' day' : ' days') + ' overdue';
    return '';
  }

  isClassificationIncomplete(): boolean {
    const v = this.taskForm.getRawValue();
    if (v.quantityRelated !== 'Yes') return false;
    return this.showQuantityState
      ? !(Array.isArray(v.quantityState) && v.quantityState.length)
      : !v.quantityNumber;
  }

  openReminderDialog(task: any) {
    this.reminderDialog = true;
    this.selectedTask = task;
  }

  openReminderNotificationDialog(task: any) {
    this.loading = true;
    let payload={"filters":[{"field":"taskId","operator":"equals","value":task.id}, {"field":"commentTargetType","operator":"equals","value":"TASK NOTIFICATION"}],"sort":[],"category":"All Tasks","searchTerm":""};
    this.notificationService.getNotificationsPaginated(null,null,payload).subscribe(res => {
      this.loading = false;
      this.reminderNotificationDialog = true;
      this.selectedTask = task;
      this.selectedTask.unreadReminderNotifications = res.data.filter((n: any) => n.read == false);
    });
  }

  handleTableTabChange(event: any) {
    if (event.index == 0) {
      this.activeTab = "default";
    } else {
      this.activeTab = "user";
    }
    this.applyTabColumns();
  }

  applyTabColumns(): void {
    // 1. Determine which reference list to use based on the tab
    const referenceList = this.activeTab === "default" ? this.defaultCols : this.customCols;

    // 2. Handle empty custom columns case
    if (this.activeTab !== "default" && (!referenceList || referenceList.length === 0)) {
        this.cols = [];
        return;
    }

    // 3. Map over the reference list to ensure its order is preserved
    this.cols = referenceList
        .map((ref: any) => {
            // Find the master definition in tableCols matching the reference field
            const masterCol = this.tableCols.find(col => col.field === ref.fieldKeyName);

            // Return the merged column with visible true, or null if not found
            return masterCol ? { ...masterCol, visible: true } : null;
        })
        .filter(col => col !== null); // Clean up any missing column matches

    this.cdr.detectChanges();

    if(this.resetcustomFilter && this.activeTab === "user"){
      this.clearAllFilters(this.table);
      this.resetcustomFilter=false;
    }else{
      const saved = this.projTasksFilter ? null : this.tableStateService.getState(this.taskScreenName+this.activeTab, this.auth.jwtData.email) as SavedTableState;

      if (saved) {
        this.restoreTaskState(saved);
      }
    }
  }
  fetchColumnSettings(): void {
    this.taskService.getTableSettings().subscribe(apiResponse => {
      apiResponse.defaultGridFields = this.sortByDisplayOrder(apiResponse.defaultGridFields || []);
      apiResponse.userViewGridFields = this.sortByDisplayOrder(apiResponse.userViewGridFields || []);
      apiResponse.availableFields = this.sortByDisplayOrder(apiResponse.availableFields || []);
      // Store the full objects, not just fieldKeyName
      this.defaultCols = Array.isArray(apiResponse?.defaultGridFields)
        ? apiResponse.defaultGridFields.filter((field: any) => field && field.fieldKeyName)
        : [];

      this.customCols = Array.isArray(apiResponse?.userViewGridFields)
        ? apiResponse.userViewGridFields.filter((field: any) => field && field.fieldKeyName)
        : [];

      this.availableColumns = Array.isArray(apiResponse?.availableFields)
        ? apiResponse.availableFields.filter((field: any) => field && field.fieldKeyName)
        : [];

      this.applyTabColumns();
    });
  }
  

  isVisible(field: string): boolean {
    if (!field || !Array.isArray(this.cols)) return false;
    try{
      return this.cols.filter((c: any) =>  c.field === field && c.visible).length > 0;
    }
    catch(error){
      console.log('Error checking visibility for field:', field, this.cols);
      console.error('Error in isVisible:', error);
      return false;
    }
  }

  viewGridSettings() {
    this.gridSettingsDialog = true;
  }

  closeSettingsDialog() {
    this.gridSettingsDialog = false;
    this.fetchColumnSettings();
  }
  sortByDisplayOrder<T extends { displayOrder?: number }>(arr: T[]): T[] {
    return [...arr].sort((a, b) => {
      const aOrder = a.displayOrder ?? Number.MAX_SAFE_INTEGER;
      const bOrder = b.displayOrder ?? Number.MAX_SAFE_INTEGER;
      return aOrder - bOrder;
    });
  }

  saveCustomSettings() {
    // this.handleTableTabChange({ index: 1 });
    this.gridSettingsDialog = false;
    this.resetcustomFilter=true;
  }

  openGridSettings() {
    this.gridSettingsDialog = true;
  }

  getDefaultGridColumns(): any[] {
    // Hard code default columns for Project Name and ID
    return [
      {
        fieldKeyName: 'projectName',
        fieldName: 'Project Name'
      },
      {
        fieldKeyName: 'taskName',
        fieldName: 'Task Name'
      },
      {
        fieldKeyName: 'id',
        fieldName: 'Task ID'
      }
    ];
  }


  showAuditData(task:any,fieldName: string,header:string) {
    this.auditField=fieldName;
    this.auditRecordId=task.id;
    this.auditDialog = true;
    this.tableName='al_project_tasks';
    
    if(fieldName=='projTaskAssignmentStatus'){
      this.auditField="assignmentStatus";
      this.auditRecordId=task.projTaskAssignmentId;
      this.tableName='al_tk_tasks_assignment';
    }
    this.auditTitle = "Audit History for " + header+" ["+this.auditRecordId+"]";
    
  }

  closeAuditDialog() {
    this.auditDialog = false;
    this.auditRecordId=null;
    this.auditField='';
    this.tableName='';
  }
  readyToCompleteConfirmPopup(task: any) {

    this.confirmMessage = `You are completing this payment. This action cannot be undone. By completing this payment you are representing you have actually made the payment and submitting to accounting. To continue, press Okay or Cancel to go back.`;
    this.showConfirmAlert = true;
    this.pendingConfirmationAction = 'markTaskReadyToComplete';
    this.selectedTask = task;
  }


  markTaskReadyToComplete(){
    this.messageService.clear();
    var payload: any = [
      {
        "projTaskId": this.taskForm.getRawValue().id,
        "billable": null,
        "status": "Ready to Complete",
        "tkRating": null,
      }
    ];
   
    this.submitted = true;
    if (this.taskForm.valid) {

      if (this.btnLoading)
            return;

      this.btnLoading = true;
      this.taskService.approveOrRejectTask(payload).subscribe(res => {
        this.scrollToTopDialog();
        this.messageService.add({ severity: 'success', detail: "Task Marked AS Ready to Complete" });
        this.viewOnly = true;
        this.btnLoading = false;
        setTimeout(() => {
          this.closeDialog();
        }, 1000);
      },
        err => {
          this.btnLoading = false;
          this.scrollToTopDialog();
          this.messageService.add({ severity: 'error', detail: "Error while Completing Payment!" });
        }
      );
    }else{
      this.scrollToTopDialog();
      this.messageService.add({ severity: 'error', detail: "All required fields must be completed before completing a payment. Please review the required fields and make sure all fields have been completed." });
    } 
  }

  onNotReadyClick(){
    this.confirmMessage = `By clicking Not Ready, you are sending this Task back to the TimeKeeper who will be able to add additional time records. You will not be able to complete this Task until the TimeKeeper re-marks the Time Record as Ready to Complete. To proceed, click Okay or Cancel to return`;
    this.showConfirmAlert = true;
    this.pendingConfirmationAction = 'notReadyToComplete';
  }

  
  notReadyToCompletePersist(){
    this.messageService.clear();
    this.messageService.add({ severity: 'info', detail: "Saving Payment Completed.." });
    var payload: any = [
      {
        "projTaskId": this.taskForm.getRawValue().id,
        "billable": null,
        "status": "Accepted",
        "tkRating": null,
      }
    ];
   
      if (this.btnLoading)
            return;

      this.btnLoading = true;
      this.taskService.approveOrRejectTask(payload).subscribe(res => {
        this.scrollToTopDialog();
        this.messageService.clear();
        this.messageService.add({ severity: 'success', detail: "Task Marked as Accepted" });
        this.viewOnly = true;
        this.btnLoading = false;
        setTimeout(() => {
          this.closeDialog();
        }, 1000);
      },
        err => {
          this.btnLoading = false;
          this.scrollToTopDialog();
          this.messageService.add({ severity: 'error', detail: "Error while Changing Ready to Complete!" });
        }
      );
   
  }

  get canShowNotReadyButton(): boolean {
    // 1. Get raw form values safely
    const rawValues = this.taskForm?.getRawValue();
    if (!rawValues) return false;

    // 2. Check completion status (handling potential null/undefined)
    const isCompleted = rawValues.isCompleted?.toUpperCase() === 'YES';

    // 3. Check status code
    const allowedStatuses = ['READY TO COMPLETE', 'FOR APPROVAL', 'APPROVED'];
    const currentStatus = rawValues.statusCode?.toUpperCase();
    const hasValidStatus = allowedStatuses.includes(currentStatus);

    // 4. Check user roles
    const hasRequiredRole = this.userrole?.includes('LPC') || this.userrole?.includes('ADMIN');

    // 5. Combine all conditions cleanly
    return !isCompleted 
      && hasValidStatus 
      && !this.viewOnly 
      && hasRequiredRole 
      && !this.tkdashboard;
  }

  getExportDisabledReason(): string {
    return 'Export in progress, please wait.';
  }

  getManageDisbursementsDisabledReason(): string {
    return 'Cannot manage disbursements: Task is completed.';
  }

  getPaymentCompletedDisabledReason(): string {
    return 'Payment cannot be completed: Task is completed, approved, or not yet accepted.';
  }

  getDeleteDisbursementDisabledReason(disbursement: any): string {
    if (disbursement?.isCompleted?.toUpperCase() === 'YES') {
      return 'Cannot delete: Disbursement task is completed.';
    }
    if (disbursement?.datePaid || disbursement?.disbursementAmount) {
      return 'Cannot delete: Disbursement has payment details.';
    }
    return '';
  }

  getReassignDisabledReason(): string {
    return 'Select a reassign reason first.';
  }

  getDeleteAssignmentDisabledReason(): string {
    return 'Select a delete reason first.';
  }

  getAcceptDisabledReason(): string {
    return 'No assignments available to accept.';
  }

  getRejectDisabledReason(): string {
    return 'No assignments available to reject.';
  }

  getEntityInfoDisabledReason(): string {
    return 'Loading entity information, please wait.';
  }

  getAddTRDisabledReason(): string {
    return 'Task is marked Ready to Complete; time records cannot be added.';
  }

  getDeleteTRDisabledReason(record: any): string {
    return record?.disableDel ? 'This time record cannot be deleted.' : '';
  }

  getDeleteReasonDisabledReason(): string {
    return 'Select a delete reason first.';
  }

  getSaveTRDisabledReason(): string {
    return 'Add at least one time record to save.';
  }

  getFARejectDisabledReason(): string {
    if (this.FAdisableFlag) {
      return 'This task has already been processed.';
    }
    if (this.radioStatus === 'approve') {
      return 'Approve is selected; switch to Reject to reject this task.';
    }
    if (!this.taskForm.getRawValue().tkRating) {
      return 'Provide a TK rating first.';
    }
    return '';
  }

  getFAApproveDisabledReason(): string {
    if (this.FAdisableFlag) {
      return 'This task has already been processed.';
    }
    if (this.radioStatus === 'reject' && !this.rejectedReason) {
      return 'Enter a rejection reason first.';
    }
    if (!this.taskForm.getRawValue().tkRating) {
      return 'Provide a TK rating first.';
    }
    return '';
  }

  getDeleteConfirmDisabledReason(): string {
    return 'Deleting, please wait.';
  }

}
